{
  "common.open": "Otwórz",
  "common.save": "Zapisz",
  "common.saving": "Zapisuję…",
  "common.cancel": "Anuluj",
  "common.delete": "Usuń",
  "common.edit": "Edytuj",
  "common.close": "Zamknij",
  "common.confirm": "Potwierdź",
  "common.ok": "OK",
  "common.field_required": "To pole jest wymagane.",
  "common.loading": "Ładowanie...",
  "common.error": "Błąd",
  "common.success": "Sukces",
  "common.warning": "Ostrzeżenie",
  "common.info": "Informacja",
  "common.search": "Szukaj",
  "common.filter": "Filtruj",
  "common.refresh": "Odśwież",
  "common.export": "Eksport",
  "common.import": "Import",
  "common.empty": "Brak danych",
  "common.required": "Wymagane",
  "common.optional": "Opcjonalne",
  "common.yes": "Tak",
  "common.no": "Nie",
  "common.back": "Wstecz",
  "common.next": "Dalej",
  "common.previous": "Poprzedni",
  "common.first": "Pierwszy",
  "common.last": "Ostatni",
  "common.all": "Wszystkie",
  "common.none": "Brak",
  "common.selected": "wybranych",
  "common.deselect": "Anuluj zaznaczenie",
  "common.export_csv": "Eksportuj wybrane do CSV",
  "common.search_placeholder": "Szukaj…",
  "common.profile": "Profil",
  "toast.saved": "Zapisano",
  "toast.deleted": "Usunięto",
  "toast.updated": "Zaktualizowano",
  "toast.error_generic": "Wystąpił błąd",
  "toast.network_error": "Błąd sieci",
  "toast.order_created": "Nowe zamówienie #{id} utworzone",
  "toast.invoice_saved": "Faktura zapisana",
  "toast.customer_created": "Klient utworzony",
  "toast.copied": "Skopiowano do schowka",
  "toast.email_sent": "Email wysłany",
  "common.actions": "Akcje",
  "common.status": "Status",
  "common.date": "Data",
  "common.amount": "Kwota",
  "common.total": "Razem",
  "dashboard.kpi.orders_today": "Zamówienia dziś",
  "dashboard.kpi.revenue_today": "Przychód dziś",
  "dashboard.kpi.new_customers": "Nowi klienci",
  "dashboard.kpi.products": "Produkty",
  "dashboard.kpi.pending": "Oczekujące",
  "dashboard.kpi.avg_value": "Średnia wartość",
  "dashboard.kpi.attention_needed": "Wymaga uwagi",
  "dashboard.kpi.top_product_week": "Top produkt (7 dni)",
  "dashboard.kpi.top_products_10": "TOP 10 produktów (7 dni)",
  "dashboard.kpi.sales_per_marketplace": "Sprzedaż według źródła",
  "dashboard.kpi.month_total": "Cały miesiąc",
  "dashboard.compare.label": "Porównaj z tym samym dniem:",
  "dashboard.compare.yesterday": "Wczoraj",
  "dashboard.compare.week_ago": "Tydzień wcześniej",
  "dashboard.compare.month_ago": "Miesiąc wcześniej",
  "dashboard.compare.year_ago": "Rok wcześniej",
  "dashboard.charts.orders_30d": "Zamówienia w ostatnich 30 dniach",
  "dashboard.charts.weekly_revenue": "Przychód tygodniowy",
  "dashboard.charts.orders_revenue_30d": "Zamówienia i przychód — ostatnie 30 dni",
  "dashboard.compare.today": "dziś",
  "dashboard.compare.today_so_far": "dziś (do tej pory)",
  "dashboard.compare.full_day": "cały dzień",
  "dashboard.kpi.sb2_sources": "Kanały i konta",
  "dashboard.compare.vs_full_day": "wobec całego dnia",
  "dashboard.compare.approx": "(najbliższy odpowiednik)",
  "dashboard.attention.empty": "Brak wątków wymagających uwagi 🎉",
  "dashboard.attention.unavailable": "Nie udało się odczytać listy — sprawdź Wiadomości i Reklamacje.",
  "dashboard.attention.all_messages": "wiadomości bez odpowiedzi",
  "dashboard.attention.all_cases": "sprawy bez odpowiedzi sprzedawcy",
  "dashboard.sparkline.partial_last": "Ostatni punkt to dzisiejszy, niepełny dzień (linia przerywana).",
  "nav.quick_add": "Szybkie dodawanie",
  "nav.tickets": "Obsługa klienta",
  "nav.tickets.inbox": "Skrzynka",
  "nav.call": "SellBase Call",
  "nav.dashboard": "Dashboard",
  "nav.orders": "Zamówienia",
  "nav.orders.list": "Wszystkie zamówienia",
  "nav.orders.drafts": "Szkice zamówień",
  "nav.orders.labels": "Etykiety",
  "nav.customers": "Klienci",
  "nav.products": "Produkty",
  "nav.products.marketplace": "Oferty marketplace",
  "nav.products.import": "Import produktów",
  "nav.products.drafts": "Poczekalnia ofert",
  "product_import.title": "Import produktów",
  "product_import.subtitle": "Importuj produkty z zewnętrznych źródeł. Skonfiguruj połączenie, wybierz które pola aktualizować i uruchom import. Postęp i historia widoczne poniżej.",
  "product_import.subtitle_tabs": "Wybierz źródło u góry, przeglądaj jego katalog i przenoś oferty do produktów SellBase.",
  "product_import.account_filter": "Konto Allegro",
  "product_import.account_all": "Wszystkie konta",
  "product_import.no_sources": "Brak dostępnych źródeł importu.",
  "product_import.load_error": "Nie udało się pobrać źródeł importu.",
  "product_import.badge_configured": "Skonfigurowane",
  "product_import.badge_not_configured": "Brak konfiguracji",
  "product_import.badge_active": "Aktywne",
  "product_import.badge_inactive": "Nieaktywne",
  "product_import.last_run": "Ostatni import",
  "product_import.never_run": "Jeszcze nie importowano",
  "product_import.action_configure": "Konfiguruj",
  "product_import.action_test": "Testuj połączenie",
  "product_import.action_run": "Importuj teraz",
  "product_import.testing": "Testuję...",
  "product_import.test_ok": "Połączenie działa poprawnie",
  "product_import.test_fail": "Test nieudany",
  "product_import.already_running": "Import już trwa — pokazuję postęp bieżącego.",
  "product_import.run_no_id": "Import uruchomiony, brak identyfikatora — odświeżam historię.",
  "product_import.run_fail": "Nie udało się uruchomić importu",
  "product_import.summary": "Import zakończony",
  "product_import.configure": "Konfiguracja",
  "product_import.source_active": "Źródło aktywne",
  "product_import.source_active_desc": "Gdy wyłączone, import z tego źródła jest zablokowany.",
  "product_import.p4u_url": "Adres URL feedu P4U",
  "product_import.p4u_url_hint": "Adres JSON feedu produktów P4U. Puste = synchronizacja wyłączona.",
  "product_import.sellasist_subdomain": "Subdomena Sellasist",
  "product_import.sellasist_subdomain_hint": "Wpisz tylko nazwę subdomeny, bez https:// i .sellasist.pl",
  "product_import.api_key": "Klucz API",
  "product_import.api_key_set": "ustawiony",
  "product_import.api_key_ph": "••• zostaw puste by nie zmieniać",
  "product_import.api_key_hint": "Klucz jest szyfrowany przy zapisie. Pozostaw puste, aby zachować obecny.",
  "product_import.options": "Opcje importu",
  "product_import.options_sub": "Wybierz które pola aktualizować dla produktów, które już istnieją w SellBase.",
  "product_import.existing_mode": "Tryb dla istniejących",
  "product_import.mode_update": "Aktualizuj",
  "product_import.mode_update_desc": "Nadpisuje wybrane pola istniejących produktów.",
  "product_import.mode_skip": "Pomiń (tylko nowe)",
  "product_import.mode_skip_desc": "Dodaje tylko nowe produkty, istniejące pozostawia.",
  "product_import.saving": "Zapisywanie...",
  "product_import.saved": "Zapisano konfigurację źródła",
  "product_import.save_fail": "Nie udało się zapisać konfiguracji",
  "product_import.unknown_source": "Nieznane źródło",
  "product_import.history": "Historia importów",
  "product_import.history_empty": "Brak importów w historii.",
  "product_import.history_error": "Nie udało się pobrać historii",
  "product_import.col_date": "Data",
  "product_import.col_source": "Źródło",
  "product_import.col_status": "Status",
  "product_import.col_fetched": "Pobrane",
  "product_import.short_fetched": "pobrane",
  "product_import.short_created": "nowe",
  "product_import.short_updated": "akt.",
  "product_import.short_skipped": "pominięte",
  "product_import.short_errors": "błędy",
  "product_import.subtitle_browse": "Przeglądaj katalog źródła, zaznacz interesujące pozycje i przenieś je do listy produktów SellBase. Postęp i historia poniżej.",
  "product_import.catalog_sub": "Katalog źródła — zaznacz pozycje i przenieś do listy produktów.",
  "product_import.action_refresh": "Odśwież katalog",
  "product_import.refresh_fail": "Nie udało się odświeżyć katalogu",
  "product_import.refresh_done": "Katalog odświeżony",
  "product_import.last_fetched": "Ostatnio pobrano",
  "product_import.in_catalog": "w katalogu",
  "product_import.new_count": "nowych",
  "product_import.only_new": "tylko nowe",
  "product_import.filter_all": "Wszystkie",
  "product_import.filter_new": "Nowe",
  "product_import.filter_imported": "Zaimportowane",
  "product_import.imported_count": "zaimportowanych",
  "product_import.search_ph": "Szukaj po nazwie, SKU, EAN…",
  "product_import.col_name": "Nazwa",
  "product_import.col_price": "Cena",
  "product_import.col_stock": "Stan",
  "product_import.in_sellbase": "W SellBase",
  "product_import.status_new": "Nowy",
  "product_import.select_new_page": "Zaznacz nowe na stronie",
  "product_import.transfer_selected": "Przenieś zaznaczone",
  "product_import.transfer_all_new": "Przenieś wszystkie nowe",
  "product_import.transfer_done": "Przeniesiono",
  "product_import.transfer_fail": "Nie udało się przenieść pozycji",
  "product_import.nothing_selected": "Nic nie zaznaczono.",
  "product_import.nothing_new_page": "Brak nowych pozycji na tej stronie.",
  "product_import.no_items": "Brak pozycji w katalogu. Kliknij „Odśwież katalog”.",
  "product_import.no_items_filter": "Brak pozycji dla bieżącego filtra.",
  "product_import.items_error": "Nie udało się pobrać katalogu",
  "product_import.items_refresh_hint": "Kliknij „Odśwież katalog”, aby pobrać pozycje ze źródła.",
  "product_import.page": "strona",
  "product_import.label_source_manual": "Ręczny",
  "product_import.label_source_p4u": "p4u",
  "product_import.label_source_sellasist": "Sellasist",
  "product_import.label_source_title": "Źródło produktu",
  "product_import.preview": "Podgląd",
  "product_import.open_in_sellbase": "Otwórz w SellBase",
  "product_import.transfer_to_sellbase": "Przenieś do SellBase",
  "product_import.transferring": "Przenoszę...",
  "product_import.description": "Opis",
  "product_import.variants": "Warianty",
  "product_import.manufacturer": "Producent",
  "product_import.category": "Kategoria",
  "product_import.no_image": "Brak zdjęcia",
  "product_import.price_promo": "Cena promocyjna",
  "product_import.preview_error": "Nie udało się pobrać szczegółów pozycji",
  "product_import.detail_partial": "Pokazano dane z bufora — nie udało się dociągnąć pełnych szczegółów ze źródła.",
  "product_import.st_match_conflict": "Konflikt: SKU istnieje już w SellBase albo EAN i SKU wskazują różne produkty — wiersz nie utworzył produktu, powiąż ręcznie lub popraw kod u źródła",
  "nav.invoices": "Faktury",
  "nav.invoices.documents": "Dokumenty",
  "nav.invoices.series": "Serie dokumentów",
  "nav.stats": "Statystyki",
  "nav.settings": "Ustawienia",
  "nav.logout": "Wyloguj",
  "orders.list.title": "Zamówienia",
  "orders.empty": "Brak zamówień",
  "orders.create": "Nowe zamówienie",
  "orders.detail": "Szczegóły zamówienia",
  "orders.column.id": "ID",
  "orders.column.customer": "Klient",
  "orders.column.products": "Produkty",
  "orders.column.status": "Status",
  "orders.column.source": "Źródło",
  "orders.column.amount": "Kwota",
  "orders.column.date": "Data",
  "customers.list.title": "Klienci",
  "customers.empty": "Brak klientów",
  "customers.create": "Nowy klient",
  "customers.column.name": "Nazwa",
  "customers.column.email": "E-mail",
  "customers.column.phone": "Telefon",
  "customers.column.orders": "Zamówienia",
  "customers.type.company": "Firma",
  "customers.type.individual": "Osoba",
  "invoices.series.save": "Zapisz serię",
  "invoices.list.title": "Faktury",
  "invoices.empty": "Brak faktur",
  "invoices.create": "Nowa faktura",
  "invoices.status.draft": "Szkic",
  "invoices.status.issued": "Wystawiona",
  "invoices.status.paid": "Opłacona",
  "invoices.status.cancelled": "Anulowana",
  "products.list.title": "Produkty",
  "products.empty": "Brak produktów",
  "products.create": "Nowy produkt",
  "products.stock.in": "Na stanie",
  "products.stock.low": "Niski stan",
  "products.stock.out": "Brak na stanie",
  "notif.new_order": "Nowe zamówienie",
  "notif.new_invoice": "Nowa faktura",
  "notif.new_customer": "Nowy klient",
  "notif.center.title": "Powiadomienia",
  "notif.center.empty": "Brak powiadomień",
  "notif.center.markAllRead": "Oznacz wszystkie",
  "notif.center.clear": "Wyczyść",
  "notif.push.enable": "Włącz",
  "notif.push.disable": "Wyłącz",
  "notif.push.title": "Push w tle (nawet z zamkniętą kartą)",
  "notif.push.permission_denied": "Brak zgody na powiadomienia",
  "theme.light": "Tryb jasny",
  "theme.dark": "Tryb ciemny",
  "theme.toggle": "Przełącz motyw",
  "plural.orders.one": "{count} zamówienie",
  "plural.orders.few": "{count} zamówienia",
  "plural.orders.many": "{count} zamówień",
  "plural.orders.other": "{count} zamówień",
  "plural.customers.one": "{count} klient",
  "plural.customers.few": "{count} klientów",
  "plural.customers.many": "{count} klientów",
  "plural.customers.other": "{count} klientów",
  "plural.products.one": "{count} produkt",
  "plural.products.few": "{count} produkty",
  "plural.products.many": "{count} produktów",
  "plural.products.other": "{count} produktów",
  "plural.invoices.one": "{count} faktura",
  "plural.invoices.few": "{count} faktury",
  "plural.invoices.many": "{count} faktur",
  "plural.invoices.other": "{count} faktur",
  "plural.notifications.one": "{count} powiadomienie",
  "plural.notifications.few": "{count} powiadomienia",
  "plural.notifications.many": "{count} powiadomień",
  "plural.notifications.other": "{count} powiadomień",
  "login.email": "Email",
  "login.password": "Hasło",
  "login.submit": "Zaloguj się",
  "login.register": "Załóż konto",
  "login.no_account": "Nie masz konta?",
  "login.has_account": "Masz już konto?",
  "login.forgot_password": "Zapomniałeś hasła?",
  "status.order.new": "Nowe",
  "status.order.processing": "W realizacji",
  "status.order.packed": "Spakowane",
  "status.order.ready_to_ship": "Do wysłania",
  "status.order.shipped": "Wysłane",
  "status.order.ready_for_pickup": "Do odbioru",
  "status.order.delivered": "Odebrane",
  "status.order.cancelled": "Anulowane",
  "status.order.returned": "Zwrot",
  "status.payment.paid": "Opłacone",
  "status.payment.partially_paid": "Częściowo opłacone",
  "status.payment.pending": "Oczekuje",
  "status.payment.partially_refunded": "Częściowo zwrócone",
  "status.payment.refunded": "Zwrócone",
  "status.payment.cod": "Pobranie",
  "status.shipment.no_shipment": "Brak przesyłki",
  "status.shipment.created": "Utworzona",
  "status.shipment.dispatched": "Nadana",
  "status.shipment.in_transit": "W transporcie",
  "status.shipment.delivered": "Dostarczona",
  "status.shipment.returned": "Zwrócona",
  "status.shipment.cancelled": "Anulowana",
  "status.customer.standard": "Standard",
  "status.customer.staly": "Stały klient",
  "status.customer.hurt": "Hurt",
  "status.customer.vip": "VIP",
  "status.customer.czarna_lista": "Czarna lista",
  "status.ksef.NOT_APPLICABLE": "Nie wysłana",
  "status.ksef.PENDING_SEND": "Oczekuje",
  "status.ksef.QUEUED": "W kolejce",
  "status.ksef.PROCESSING": "Przetwarzanie",
  "status.ksef.ACCEPTED": "Zaakceptowana",
  "status.ksef.REJECTED": "Odrzucona",
  "status.ksef.ERROR": "Błąd",
  "status.invoice.draft": "Szkic",
  "status.invoice.issued": "Wystawiona",
  "status.invoice.approved": "Zatwierdzona",
  "status.invoice.sent": "Wysłana",
  "status.invoice.paid_partial": "Częściowo opłacona",
  "status.invoice.paid": "Opłacona",
  "status.invoice.overdue": "Zaległa",
  "status.invoice.cancelled": "Anulowana",
  "status.invoice_type.invoice": "Faktura VAT",
  "status.invoice_type.proforma": "PRO — Proforma",
  "status.invoice_type.receipt": "Paragon",
  "status.invoice_type.correction": "Korekta",
  "status.invoice_type.wdt": "WDT",
  "status.invoice_type.oss": "OSS",
  "status.ticket.new": "Nowa",
  "status.ticket.assigned": "Przypisana",
  "status.ticket.in_progress": "W trakcie",
  "status.ticket.waiting_for_customer": "Czeka na klienta",
  "status.ticket.waiting_for_internal_action": "Czeka wewnętrznie",
  "status.ticket.resolved": "Rozwiązana",
  "status.ticket.closed": "Zamknięta",
  "status.ticket.closed_refunded": "Zamknięta (zwrot)",
  "status.ticket.closed_reshipped": "Zamknięta (dosyłka)",
  "status.ticket.closed_rejected": "Zamknięta (odrzucona)",
  "status.ticket_type.standard_message": "Wiadomość",
  "status.ticket_type.allegro_discussion": "Dyskusja",
  "status.ticket_type.allegro_claim": "Reklamacja",
  "status.ticket_type.complaint": "Reklamacja",
  "status.issue.DISPUTE_ONGOING": "W toku",
  "status.issue.DISPUTE_CLOSED": "Zamknięta",
  "status.issue.DISPUTE_UNRESOLVED": "Nierozwiązana",
  "status.issue.CLAIM_SUBMITTED": "Zgłoszona",
  "status.issue.CLAIM_ACCEPTED": "Zaakceptowana",
  "status.issue.CLAIM_REJECTED": "Odrzucona",
  "errors.unauthorized": "Brak autoryzacji",
  "errors.forbidden": "Brak uprawnień",
  "errors.not_found": "Nie znaleziono",
  "errors.server": "Błąd serwera",
  "errors.network": "Błąd sieci",
  "errors.rate_limited": "Zbyt wiele żądań. Spróbuj ponownie później.",
  "offer_drafts.title": "Poczekalnia ofert",
  "offer_drafts.subtitle": "Gotowe oferty przygotowane w module add (tytuł, opis AI, zdjęcia, parametry, GPSR). Sprawdź szczegóły i wystaw na Allegro jednym kliknięciem.",
  "offer_drafts.filter_ready": "Gotowe",
  "offer_drafts.filter_published": "Wystawione",
  "offer_drafts.filter_rejected": "Odrzucone",
  "offer_drafts.filter_error": "Błędy",
  "offer_drafts.filter_all": "Wszystkie",
  "offer_drafts.empty": "Brak ofert w tym widoku. Oferty wysłane z modułu add pojawią się tutaj automatycznie.",
  "offer_drafts.load_error": "Nie udało się pobrać poczekalni ofert.",
  "offer_drafts.col_offer": "Oferta",
  "offer_drafts.col_price": "Cena",
  "offer_drafts.col_qty": "Ilość",
  "offer_drafts.col_updated": "Aktualizacja",
  "offer_drafts.col_status": "Status",
  "offer_drafts.col_actions": "Akcje",
  "offer_drafts.publish": "Wystaw",
  "offer_drafts.publish_full": "Wystaw na Allegro",
  "offer_drafts.channels_btn": "Kanały…",
  "offer_drafts.channels_hint": "Na których marketplace i kontach ten produkt ma mieć ofertę — i wystawienie od razu",
  "offer_drafts.step_aria": "Kroki",
  "offer_drafts.step1": "Produkt SellBase",
  "offer_drafts.step2": "Kanały i wystawienie",
  "offer_drafts.step2_title": "Gdzie ten produkt ma być wystawiony?",
  "offer_drafts.step2_no_product": "Szkic nie ma powiązanego produktu",
  "offer_drafts.step2_state_has": "ma ofertę",
  "offer_drafts.step2_state_inactive": "oferta nieaktywna",
  "offer_drafts.step2_state_missing": "brak oferty",
  "offer_drafts.step2_state_off": "wyłączone",
  "offer_drafts.step2_publish_now": "wystaw teraz",
  "offer_drafts.step2_open_listing": "Otwórz wystawianie",
  "offer_drafts.step2_via_porzadek": "z kolejki „Do wystawienia”",
  "offer_drafts.step2_want": "ma być",
  "offer_drafts.step2_lead": "Produkt {name} istnieje w SellBase. Zaznaczone konto = ma tam być aktywna oferta (SellBase będzie pilnować pokrycia). Odznacz, jeśli ma go tam nie być.",
  "offer_drafts.step2_col_account": "Konto",
  "offer_drafts.step2_col_state": "Dziś",
  "offer_drafts.step2_col_now": "Wystawienie",
  "offer_drafts.step2_no_targets": "Firma nie ma aktywnych kont marketplace — nie ma gdzie wystawiać.",
  "offer_drafts.step2_note": "Pominięcie zostawia domyślne pilnowanie (wszystkie konta). Kanały i wystawienie znajdziesz później pod „Kanały…” w szkicu.",
  "offer_drafts.step2_save": "Zapisz kanały",
  "offer_drafts.step2_skip": "Pomiń",
  "offer_drafts.step2_save_publish": "Zapisz i wystaw na {n} kont",
  "offer_drafts.step2_saved": "Kanały zapisane: {n} zmian",
  "offer_drafts.step2_sub": "Zaznaczone konta SellBase będzie pilnować; wystawienie od razu jest opcją, nie obowiązkiem.",
  "offer_drafts.step2_inactive_note": "Oferty z „wystaw teraz” powstają jako nieaktywne — aktywujesz je po przeglądzie (zmienisz w następnym oknie).",
  "offer_drafts.publishing": "Wystawianie...",
  "offer_drafts.reject": "Odrzuć",
  "offer_drafts.restore": "Przywróć",
  "offer_drafts.retry": "Spróbuj ponownie",
  "offer_drafts.rejected_toast": "Oferta odrzucona",
  "offer_drafts.restored_toast": "Oferta przywrócona do poczekalni",
  "offer_drafts.published_toast": "Oferta wystawiona na Allegro",
  "offer_drafts.published_at": "Wystawiono",
  "offer_drafts.error_title": "Błąd publikacji",
  "offer_drafts.meta_price": "Cena",
  "offer_drafts.meta_qty": "Ilość",
  "offer_drafts.meta_category": "Kategoria",
  "offer_drafts.meta_brand": "Marka",
  "offer_drafts.meta_producer_code": "Kod producenta",
  "offer_drafts.photos": "Zdjęcia",
  "offer_drafts.parameters": "Parametry",
  "offer_drafts.description": "Opis oferty",
  "offer_drafts.pick_account": "Wystaw na Allegro — wybierz konto",
  "offer_drafts.no_accounts": "Brak podpiętych kont Allegro. Połącz konto w Ustawienia → Marketplace → Allegro.",
  "offer_drafts.chip_bound": "Powiązany: {name}",
  "offer_drafts.chip_bound_title": "Szkic powiązany z produktem SellBase — kliknij, aby otworzyć",
  "offer_drafts.chip_deleted": "Produkt usunięty",
  "offer_drafts.chip_deleted_title": "Powiązany produkt został usunięty — otwórz szkic i powiąż inny.",
  "offer_drafts.chip_auto_bind": "przy wystawieniu powiąże się automatycznie",
  "offer_drafts.match_title": "Produkt SellBase",
  "offer_drafts.bound_deleted_note": "Powiązany produkt został usunięty — powiąż szkic z innym produktem.",
  "offer_drafts.bound_open_title": "Otwórz produkt",
  "offer_drafts.bound_rebind": "Powiąż inny",
  "offer_drafts.bound_change": "Zmień",
  "offer_drafts.bound_unbind": "Odepnij",
  "offer_drafts.bound_unbind_title": "Zdejmij powiązanie ze szkicu (produkt zostaje)",
  "offer_drafts.bind_this": "Powiąż",
  "offer_drafts.konflikt_title": "Konflikt identyfikatorów:",
  "offer_drafts.konflikt_note": "EAN i SKU wskazują RÓŻNE produkty — wybierz właściwy w oknie powiązania.",
  "offer_drafts.similarity": "podobieństwa",
  "offer_drafts.no_match": "Brak produktu o tym EAN/SKU i podobnym tytule.",
  "offer_drafts.auto_bind_note": "Przy wystawieniu powiąże się automatycznie z: {name}",
  "offer_drafts.product_button": "Produkt SellBase",
  "offer_drafts.confirm_publish_title": "Wystawić ofertę?",
  "offer_drafts.confirm_publish": "Wystawisz ofertę na: {accounts}. Kontynuować?",
  "offer_drafts.confirm_publish_ok": "Wystaw",
  "offer_drafts.modal_open_error": "Nie udało się otworzyć okna produktu: ",
  "offer_drafts.unbind_confirm_title": "Odpiąć produkt?",
  "offer_drafts.unbind_confirm": "Szkic straci powiązanie z produktem SellBase. Produkt zostaje w katalogu. Bez powiązania oferty nie da się wystawić.",
  "offer_drafts.unbind_toast": "Powiązanie usunięte",
  "offer_drafts.gate_toast": "Najpierw powiąż szkic z produktem SellBase — bez tego oferta nie zostanie wystawiona.",
  "offer_drafts.gate_deleted_toast": "Powiązany produkt został usunięty — powiąż szkic z innym produktem.",
  "offer_drafts.gate_skipped": "Pominięto:",
  "offer_drafts.gate_bind_button": "Powiąż produkt",
  "offer_drafts.gate_link_error": "Oferta wystawiona, ale nie udało się powiązać z produktem: {error}",
  "offer_drafts.pick_catalog_wait": "Wybierz produkt katalogowy Allegro…",
  "offer_drafts.pick_catalog_skipped": "Nie wybrano produktu katalogowego — konto pominięte.",
  "offer_drafts.publish_anyway": "Wystaw mimo to",
  "offer_drafts.gallery_title": "Galeria produktu",
  "offer_drafts.gallery_main_aria": "Podgląd zdjęcia",
  "offer_drafts.gallery_empty_title": "Dodaj zdjęcie produktu",
  "offer_drafts.gallery_empty_sub": "JPG, PNG lub WebP · maks. 10 MB",
  "offer_drafts.gallery_set_main": "Ustaw jako główne",
  "offer_drafts.gallery_remove": "Usuń",
  "offer_drafts.gallery_thumbs_aria": "Zdjęcia produktu",
  "offer_drafts.gallery_add_disk": "Dodaj z dysku",
  "offer_drafts.gallery_add_url": "Dodaj z adresu URL",
  "offer_drafts.gallery_url_add": "Dodaj",
  "offer_drafts.gallery_note": "Przeciągnij miniatury, aby zmienić kolejność. Pierwsze zdjęcie jest główne. Delete usuwa zaznaczone, Enter ustawia je jako główne.",
  "offer_drafts.gallery_main_badge": "Zdjęcie główne",
  "offer_drafts.gallery_photo_n": "Zdjęcie {n} z {m}",
  "offer_drafts.gallery_photo_title": "Zdjęcie {n}",
  "offer_drafts.gallery_dup": "To zdjęcie jest już w galerii",
  "offer_drafts.gallery_limit": "Galeria może zawierać maksymalnie {n} zdjęć",
  "offer_drafts.gallery_first_n": "Dodano pierwsze {n} zdjęć",
  "offer_drafts.gallery_no_api": "Brak połączenia z API — nie mogę wysłać zdjęcia",
  "offer_drafts.gallery_uploading": "Wysyłam {n}/{m}…",
  "offer_drafts.gallery_bad_type": "obsługiwane są JPG, PNG i WebP",
  "offer_drafts.gallery_too_big": "maksymalny rozmiar zdjęcia to 10 MB",
  "offer_drafts.gallery_upload_failed": "Nie udało się dodać",
  "offer_drafts.gallery_bad_url": "Wpisz pełny adres http:// lub https://",
  "offer_drafts.modal_title": "Produkt SellBase dla tej oferty",
  "offer_drafts.modal_sub": "Bez powiązania z produktem oferta nie zostanie wystawiona — pakowacz musi widzieć, co zdjąć z półki.",
  "offer_drafts.modal_load_error": "Nie udało się pobrać szkicu: ",
  "offer_drafts.modal_cand_chosen": "Wybrany",
  "offer_drafts.modal_cand_bind": "To ten produkt — powiąż",
  "offer_drafts.modal_cand_open": "Otwórz",
  "offer_drafts.modal_cand_open_title": "Otwiera kartę produktu w nowej karcie przeglądarki",
  "offer_drafts.modal_left_title": "Oferta z Aukcjonera",
  "offer_drafts.modal_photo_preview": "Powiększ",
  "offer_drafts.modal_konflikt": "Konflikt EAN↔SKU:",
  "offer_drafts.modal_konflikt_note": "identyfikatory wskazują dwa różne produkty. Wybierz właściwy — tworzenie nowego jest zablokowane.",
  "offer_drafts.modal_sim_meta": "podobny tytuł",
  "offer_drafts.modal_dups_title": "Możliwe duplikaty",
  "offer_drafts.modal_dups_none": "Brak podobnych produktów w katalogu firmy.",
  "offer_drafts.modal_dups_typed": "dla wpisanych SKU/EAN",
  "offer_drafts.modal_typed_hits": "Firma ma już produkt o wpisanym SKU/EAN — tworzenie duplikatu jest zablokowane.",
  "offer_drafts.modal_deleted": "usunięty",
  "offer_drafts.modal_product_load_error": "Nie udało się pobrać produktu #{id}",
  "offer_drafts.modal_right_title": "Produkt SellBase",
  "offer_drafts.modal_choose_title": "Wybierz właściwy produkt po lewej",
  "offer_drafts.modal_choose_konflikt": "EAN i SKU tej oferty wskazują dwa różne produkty. Kliknij „To ten produkt — powiąż\" przy właściwym — nowego produktu nie tworzymy, żeby nie robić duplikatu.",
  "offer_drafts.modal_choose_many": "Kilka produktów firmy ma ten EAN/SKU. Kliknij „To ten produkt — powiąż\" przy właściwym — nowego produktu nie tworzymy, żeby nie robić duplikatu.",
  "offer_drafts.modal_create_submit": "Utwórz produkt i powiąż",
  "offer_drafts.modal_stock": "stan",
  "offer_drafts.modal_create_instead": "Utwórz nowy zamiast tego",
  "offer_drafts.modal_offer_photos": "Zdjęcia z oferty",
  "offer_drafts.modal_offer_photos_hint": "Dodaj do galerii produktu i ustaw jako główne, jeśli to lepsze zdjęcie.",
  "offer_drafts.modal_added": "dodane",
  "offer_drafts.modal_add_photo": "dodaj",
  "offer_drafts.modal_offer_photos_none": "Paczka nie zawiera zdjęć.",
  "offer_drafts.modal_bind_note": "Powiązanie zapisze się na szkicu. Galeria produktu zmieni się tylko, jeśli ją tu zmodyfikujesz.",
  "offer_drafts.modal_bind_submit": "Powiąż",
  "offer_drafts.modal_bind_submit_images": "Powiąż i zapisz zdjęcia",
  "offer_drafts.modal_product_gallery": "Galeria produktu",
  "offer_drafts.modal_has_hits": "Firma ma już produkt o tym EAN/SKU",
  "offer_drafts.modal_has_hits_note": "Powiąż istniejący produkt z listy po lewej — tworzenie duplikatu jest zablokowane.",
  "offer_drafts.modal_name": "Nazwa produktu",
  "offer_drafts.modal_name_required": "Nazwa jest wymagana.",
  "offer_drafts.modal_name_hint_seo": "To tytuł SEO z Allegro — pakowacz widzi nazwę produktu, możesz ją uprościć.",
  "offer_drafts.modal_sku_required": "SKU jest wymagane — pakowanie i stany magazynowe idą po SKU.",
  "offer_drafts.modal_ean_hint": "13 cyfr albo puste (bez EAN).",
  "offer_drafts.modal_ean_invalid": "EAN musi mieć dokładnie 13 cyfr — popraw albo wyczyść pole (produkt bez EAN).",
  "offer_drafts.modal_stock_note": "Stan magazynowy startuje od 0 — uzupełnij go po przyjęciu towaru. Parametry Allegro z paczki zapiszą się w polach produktu.",
  "offer_drafts.modal_fix_fields": "Popraw zaznaczone pola.",
  "offer_drafts.modal_bound_toast": "Produkt powiązany: {name}",
  "offer_drafts.modal_save_error": "Nie udało się zapisać",
  "offer_drafts.modal_dup_hint": "Wybierz właściwy produkt po lewej — sekcja „Możliwe duplikaty\" — i kliknij „To ten produkt — powiąż\".",
  "status.payment.cod_paid": "Opłacone (pobranie)",
  "nav.customers.list": "Lista klientów",
  "nav.customers.blacklist": "Czarna lista",
  "offer_drafts.filter_todo": "Do zrobienia",
  "offer_drafts.subtitle_html": "Paczki przygotowane w aukcjonerze (add). Tu robisz jedno: <b>kartę SellBase</b>. Od karty dalej — treść, konta i wystawianie — prowadzi <b>karta produktu</b>.",
  "offer_drafts.search_ph": "Szukaj: tytuł, SKU, EAN",
  "offer_drafts.legend_none": "{n} bez produktu",
  "offer_drafts.legend_konflikt": "{n} konflikt do rozstrzygnięcia",
  "offer_drafts.legend_ready": "{n} do wystawienia",
  "offer_drafts.section_product": "Najpierw karta SellBase",
  "offer_drafts.section_publish": "Gotowe do wystawienia",
  "offer_drafts.section_published": "Wystawione",
  "offer_drafts.section_rejected": "Odrzucone",
  "offer_drafts.empty_search": "Brak ofert pasujących do „{q}”.",
  "offer_drafts.empty_todo": "Wszystko zrobione. Nowe paczki z aukcjonera (add) pojawią się tutaj; produkty z kartą obsługujesz w karcie produktu.",
  "offer_drafts.todo_hint": "Wystawione i odrzucone oferty są w osobnych filtrach, żeby „Do zrobienia” pokazywało tylko to, co wymaga Twojej decyzji.",
  "offer_drafts.step1_none": "Brak karty SellBase",
  "offer_drafts.step1_deleted": "Powiązany produkt został usunięty",
  "offer_drafts.step1_konflikt": "EAN i SKU wskazują dwa różne produkty",
  "offer_drafts.tag_by_sku": "po SKU",
  "offer_drafts.tag_by_ean": "po EAN",
  "offer_drafts.step2_wait": "Wystawianie: po utworzeniu karty",
  "offer_drafts.step2_wait_choice": "Allegro: czeka na wybór produktu",
  "offer_drafts.step2_paused": "Allegro: krok wstrzymany",
  "offer_drafts.step2_error": "wystawienie nie powiodło się",
  "offer_drafts.step2_next": "Allegro: jeszcze nie wystawiona",
  "offer_drafts.cta_add_product": "Dodaj produkt",
  "offer_drafts.cap_add_product": "zdjęcia i nazwa z oferty",
  "offer_drafts.cta_choose_product": "Wybierz produkt",
  "offer_drafts.cap_deleted": "poprzedni produkt usunięto",
  "offer_drafts.cap_konflikt": "bez tego nie wystawisz",
  "offer_drafts.cta_publish": "Wystaw na Allegro",
  "offer_drafts.cap_publish": "konto wybierzesz dalej",
  "offer_drafts.cta_republish": "Wystaw ponownie na Allegro",
  "offer_drafts.cap_republish": "pełna odpowiedź Allegro: menu ⋯",
  "offer_drafts.cta_open": "Otwórz na Allegro",
  "offer_drafts.cta_details": "Szczegóły",
  "offer_drafts.cap_published": "kolejne konto: menu ⋯",
  "offer_drafts.cap_restore": "wróci do „Do zrobienia”",
  "offer_drafts.sent": "wysłano",
  "offer_drafts.no_title": "(bez tytułu)",
  "offer_drafts.more": "Więcej",
  "offer_drafts.menu_details": "Szczegóły oferty",
  "offer_drafts.menu_edit": "Edytuj tytuł, cenę, zdjęcia",
  "offer_drafts.menu_change_product": "Zmień produkt",
  "offer_drafts.menu_unbind": "Odepnij produkt",
  "offer_drafts.menu_allegro_response": "Odpowiedź Allegro",
  "offer_drafts.fix_defaults": "Uzupełnij warunki konta",
  "offer_drafts.fix_defaults_short": "uzupełnij",
  "offer_drafts.fix_defaults_title": "Otwórz ustawienia publikacji tego konta i uzupełnij braki",
  "offer_drafts.fix_defaults_error": "Nie udało się otworzyć ustawień konta: ",
  "offer_drafts.card_open_product": "Otwórz produkt SellBase",
  "offer_drafts.step1_unbound_published": "Produkt SellBase: brak powiązania",
  "offer_drafts.step1_unbound_published_title": "Oferta wystawiona zanim powiązania z produktem istniały. Powiąż ją przez menu ⋯ → Powiąż produkt.",
  "offer_drafts.menu_bind_product": "Powiąż produkt",
  "offer_drafts.hist_tab_details": "Szczegóły",
  "offer_drafts.hist_flag_backfill": "odtworzone z archiwum",
  "offer_drafts.hist_flag_auto": "automatycznie",
  "offer_drafts.hist_stage_gate": "zatrzymane na bramce: brak produktu SellBase",
  "offer_drafts.hist_stage_exception": "awaria przed wysłaniem do Allegro",
  "offer_drafts.hist_tab_history": "Historia",
  "offer_drafts.hist_tab_feed": "Historia",
  "offer_drafts.hist_empty": "Brak historii",
  "offer_drafts.hist_feed_empty": "Brak zdarzeń dla tych filtrów",
  "offer_drafts.hist_load_error": "Nie udało się pobrać historii.",
  "offer_drafts.hist_more": "Pokaż więcej",
  "offer_drafts.hist_on": "na",
  "offer_drafts.hist_system": "System",
  "offer_drafts.hist_open_offer": "Otwórz ofertę",
  "offer_drafts.hist_draft_deleted": "Szkic usunięty",
  "offer_drafts.hist_src_marketplace": "z marketplace",
  "offer_drafts.hist_missing_params": "Brakujące parametry",
  "offer_drafts.hist_col_field": "Pole",
  "offer_drafts.hist_col_before": "Przed",
  "offer_drafts.hist_col_after": "Po",
  "offer_drafts.hist_sum_received": "Przyjęto",
  "offer_drafts.hist_sum_from": "od",
  "offer_drafts.hist_sum_product_by": "Produkt utworzył",
  "offer_drafts.hist_sum_published_by": "Wystawił",
  "offer_drafts.hist_sum_edited_by": "Edytował",
  "offer_drafts.hist_same_person": "ta sama osoba",
  "offer_drafts.hist_diff_person": "różne osoby",
  "offer_drafts.hist_today": "Dziś",
  "offer_drafts.hist_yesterday": "Wczoraj",
  "offer_drafts.hist_day_unknown": "Bez daty",
  "offer_drafts.hist_f_kind": "Rodzaj",
  "offer_drafts.hist_f_user": "Osoba",
  "offer_drafts.hist_f_account": "Konto",
  "offer_drafts.hist_f_from": "od",
  "offer_drafts.hist_f_to": "do",
  "offer_drafts.hist_f_all_kinds": "Wszystkie rodzaje",
  "offer_drafts.hist_f_all_users": "Wszystkie osoby",
  "offer_drafts.hist_f_all_accounts": "Wszystkie konta",
  "offer_drafts.hist_f_search_ph": "Szukaj: tytuł, SKU, produkt",
  "offer_drafts.hist_kind_inbound": "Przyjęto z aukcjonera",
  "offer_drafts.hist_kind_inbound_update": "Ponownie wysłano z aukcjonera",
  "offer_drafts.hist_kind_edit": "Edytowano szkic",
  "offer_drafts.hist_kind_product_created": "Utworzono produkt SellBase",
  "offer_drafts.hist_kind_product_bound": "Powiązano z produktem",
  "offer_drafts.hist_kind_product_unbound": "Odpięto produkt",
  "offer_drafts.hist_kind_publish_ok": "Wystawiono",
  "offer_drafts.hist_kind_publish_failed": "Wystawienie nie powiodło się",
  "offer_drafts.hist_kind_rejected": "Odrzucono",
  "offer_drafts.hist_kind_restored": "Przywrócono",
  "offer_drafts.hist_kind_deleted": "Usunięto szkic",
  "offer_drafts.hist_kind_offer_first_active": "Oferta aktywna",
  "offer_drafts.hist_kind_offer_ended": "Oferta zakończona",
  "offer_drafts.hist_kind_offer_price_changed": "Zmiana ceny oferty",
  "offer_drafts.hist_kind_mismatch_confirmed": "Potwierdzono rozjazd kodów paczka↔produkt",
  "offer_drafts.hist_field_title": "Tytuł",
  "offer_drafts.hist_field_name": "Tytuł",
  "offer_drafts.hist_field_price": "Cena",
  "offer_drafts.hist_field_quantity": "Ilość",
  "offer_drafts.hist_field_images": "Zdjęcia",
  "offer_drafts.hist_field_images_count": "Zdjęcia",
  "offer_drafts.hist_field_brand": "Marka",
  "offer_drafts.hist_field_producer_code": "Kod producenta",
  "offer_drafts.hist_field_parameters": "Parametry",
  "offer_drafts.hist_field_allegro_draft": "Payload Allegro",
  "offer_drafts.hist_field_ean": "EAN",
  "offer_drafts.hist_field_sku": "SKU",
  "offer_drafts.hist_field_description": "Opis",
  "offer_drafts.hist_field_category": "Kategoria",
  "offer_drafts.hist_field_category_id": "Kategoria",
  "offer_drafts.hist_field_reason": "Powód",
  "offer_drafts.hist_field_sent_by": "Wysłał",
  "offer_drafts.hist_field_offer_status": "Status oferty",
  "offer_drafts.hist_field_product_status": "Status produktu",
  "offer_drafts.hist_field_remapped_count": "Przemapowane parametry",
  "offer_drafts.hist_field_environment": "Środowisko",
  "offer_drafts.hist_field_end_reason": "Powód zakończenia",
  "offer_drafts.hist_field_price_before": "Cena przed",
  "offer_drafts.hist_field_price_after": "Cena po",
  "offer_drafts.hist_field_old_price": "Cena przed",
  "offer_drafts.hist_field_new_price": "Cena po",
  "offer_drafts.hist_field_currency": "Waluta",
  "offer_drafts.hist_field_gate_code": "Kod bramki",
  "offer_drafts.hist_field_roznice": "Różnice paczka↔produkt",
  "offer_drafts.hist_field_roznice_potwierdzone": "Potwierdzone różnice",
  "offer_drafts.hist_field_stage": "Etap",
  "offer_drafts.inactive_hint": "Oferta trafi na Allegro jako szkic (nieaktywna): dokończysz ją i wystawisz na Allegro albo w Ofertach marketplace",
  "offer_drafts.inactive_label": "jako szkic (nieaktywna)",
  "offer_drafts.check_hint": "Te same kontrole co przy wystawieniu (powiązanie, profil konta, produkt katalogowy, wymagane parametry) — bez zapisu na koncie",
  "offer_drafts.check_btn": "Sprawdź (tryb próbny)",
  "offer_drafts.checking": "Sprawdzam…",
  "offer_drafts.probe_ok": "Gotowe do wystawienia — kontrole przeszły",
  "offer_drafts.probe_err": "Blokady:",
  "offer_drafts.confirm_inactive": "(jako NIEAKTYWNĄ — aktywacja osobno)",
  "mpo.fam_accounts_n": "{n} kont",
  "mpo.fam_act_compare": "Porównaj duplikaty",
  "mpo.fam_act_create": "Utwórz produkt",
  "mpo.fam_act_link": "Powiąż",
  "mpo.fam_act_open_product": "Karta produktu",
  "mpo.fam_col_listed_offer": "Wystawiono",
  "mpo.fam_open_on": "Otwórz na {mp}",
  "mpo.fam_col_marketplaces": "Marketplace · konta",
  "mpo.fam_col_origin": "Pochodzenie / nr oferty",
  "mpo.fam_col_price": "Cena",
  "mpo.fam_newest_short": "z {n}",
  "mpo.fam_col_product": "Produkt / oferta",
  "mpo.fam_col_stock": "Stan",
  "mpo.fam_compare_hint": "Oferty rozwinięte — porównaj duplikaty i zdecyduj, którą zakończyć.",
  "mpo.fam_count": "{od}–{do} z {total} produktów · {oferty} ofert",
  "mpo.fam_count_empty": "0 produktów",
  "mpo.fam_date_approx_hint": "Kanał nie podaje daty wystawienia — pierwsze pobranie do SellBase ",
  "mpo.fam_date_hint": "Wystawiono ",
  "mpo.fam_detail_aria": "Szczegóły produktu",
  "mpo.fam_detail_decisions": "Wymaga decyzji",
  "mpo.fam_detail_error": "Nie udało się wczytać szczegółów",
  "mpo.fam_detail_history": "Historia",
  "mpo.fam_nav_label": "Rodzina {i} z {n}",
  "mpo.fam_open_on_marketplace": "Otwórz na marketplace",
  "mpo.fam_detail_offers": "Oferty tego produktu",
  "mpo.fam_detail_product": "Produkt SellBase",
  "mpo.fam_empty": "Brak produktów dla tych filtrów",
  "mpo.fam_pill_unit_groups": "grup ofert",
  "mpo.fam_pill_unit_products": "produktów",
  "mpo.fam_pill_count_hint": "{n} {j} w obecnych filtrach",
  "mpo.fam_filter_origin": "Pochodzenie",
  "mpo.fam_filter_channel": "Kanał",
  "mpo.fam_filter_search": "Szukaj",
  "mpo.fam_filter_linked": "Tylko powiązane",
  "mpo.fam_empty_active": "Włączone filtry:",
  "mpo.fam_empty_clear_one": "Wyłącz ten filtr",
  "mpo.fam_empty_clear_all": "Wyczyść wszystkie",
  "mpo.fam_from_offer": "Z oferty",
  "mpo.fam_from_offer_v": "tytuł, EAN, SKU, cena, zdjęcia",
  "mpo.fam_history_empty": "Brak historii",
  "mpo.fam_key_title": "grupa po tytule, niepewna",
  "mpo.fam_key_title_hint": "Brak EAN i SKU — grupa zbudowana po tytule, może łączyć różne produkty",
  "mpo.fam_links_n": "{n} powiązań",
  "mpo.fam_load_error": "Nie udało się wczytać produktów",
  "mpo.fam_load_error_hint": "Przejdź na „Płaską listę\"",
  "mpo.fam_loading": "Wczytuję produkty…",
  "mpo.fam_loading_offers": "Wczytuję oferty…",
  "mpo.fam_no_decisions": "Nic nie wymaga decyzji.",
  "mpo.fam_no_product": "brak produktu",
  "mpo.fam_no_product_title": "Brak produktu SellBase",
  "mpo.fam_offer_linked": "powiązana",
  "mpo.fam_offer_stock": "stan {n}",
  "mpo.fam_offer_unlinked": "bez powiązania",
  "mpo.fam_offers_empty": "Brak ofert",
  "mpo.fam_offers_error": "Nie udało się wczytać ofert",
  "mpo.fam_offers_shown": "{n} · pokazuję {m}",
  "mpo.fam_origin_group": "Pochodzenie ofert",
  "mpo.fam_origin_imported": "pobrane",
  "mpo.fam_origin_imported_hint": "Oferty wystawione poza SellBase, pobrane z marketplace",
  "mpo.fam_origin_pending": "czeka na Allegro",
  "mpo.fam_origin_pending_hint": "Wystawione z SellBase, jeszcze nieaktywne na Allegro",
  "mpo.fam_origin_sellbase": "z SellBase",
  "mpo.fam_origin_sellbase_hint": "Oferty wystawione z SellBase (Poczekalnia, kreator)",
  "mpo.fam_page_of": "Strona {p} z {n}",
  "mpo.fam_pill_all": "Wszystkie",
  "mpo.fam_pill_imported": "Pobrane z integracji",
  "mpo.fam_pill_pending": "Czekają na Allegro",
  "mpo.fam_pill_sellbase": "Utworzone w SellBase",
  "mpo.fam_prod_id": "ID",
  "mpo.fam_product_open_fail": "Nie mogę otworzyć karty produktu #{id}",
  "mpo.fam_proposal": "To propozycja — decyzję podejmujesz Ty, nic nie zmieniam automatycznie.",
  "mpo.fam_rel_days": "{n} dni temu",
  "mpo.fam_rel_today": "dziś",
  "mpo.fam_rel_yesterday": "wczoraj",
  "mpo.fam_search_ph": "Szukaj: nazwa, SKU, EAN, numer oferty",
  "mpo.fam_sig_duplicate_on_account": "Duplikaty na jednym koncie: {n} ofert o tym samym tytule, cenie i zdjęciu.",
  "mpo.fam_sig_no_product": "Oferty bez produktu SellBase — utwórz produkt z oferty albo powiąż z istniejącym.",
  "mpo.fam_sig_other": "Sygnał „{k}\" ({n})",
  "mpo.fam_sig_price_outlier": "Cena odstająca: {n} ofert powyżej 2,5× mediany — sprawdź, czy to nie zestaw pod tym samym EAN.",
  "mpo.fam_since": "od {od}",
  "mpo.fam_sort_newest": "Najnowsze na marketplace",
  "mpo.fam_sort_price_asc": "Cena: najniższa",
  "mpo.fam_sort_price_desc": "Cena: najwyższa",
  "mpo.fam_sort_stock_desc": "Stan: największy",
  "mpo.fam_sort_title": "Sortowanie produktów",
  "mpo.fam_sort_title_asc": "Nazwa: A→Z",
  "mpo.fam_sub_accounts": "{n} kont",
  "mpo.fam_sub_marketplaces": "{n} marketplace",
  "mpo.fam_sub_offers": "{n} ofert",
  "mpo.fam_switch_flat": "Numer oferty — przełączam na „Płaską listę\"",
  "mpo.fam_view_families": "Produkty (pnie SKU)",
  "mpo.fam_view_flat": "Płaska lista",
  "mpo.fam_rail_bledne": "Błędne powiązanie",
  "mpo.fam_rail_bez_produktu": "Bez produktu",
  "mpo.fam_rail_krotnosc": "Krotność ofert",
  "mpo.fam_rail_uwaga": "Wymaga uwagi",
  "mpo.fam_sort_uwaga": "Najpierw wymagające uwagi",
  "mpo.fam_sort_pien": "Pień SKU: A→Z",
  "mpo.fam_sig_link_bledne": "{n} ofert podpiętych do innego produktu (SKU oferty ≠ SKU produktu).",
  "mpo.fam_sig_krotnosc": "{n} ofert z liczbą w tytule inną niż mnożnik — potwierdź krotność.",
  "mpo.fam_col_sold_hint": "Sprzedane sztuki (z atrybucji zamówień); w tooltipie ostatnie 30 dni",
  "mpo.fam_col_sold": "Sprzedane",
  "mpo.fam_col_link": "Powiązanie",
  "mpo.fam_count_groups": "{od}–{do} z {total} grup bez produktu · {oferty} ofert",
  "mpo.fam_pien_meta": "{p} produktów · {o} ofert",
  "mpo.fam_pien_bledne": "{n} ofert podpiętych do innego produktu",
  "mpo.fam_pien_krotnosc": "{n} ofert z krotnością do potwierdzenia",
  "mpo.fam_offers_n": "{n} ofert",
  "mpo.fam_brak_kanalow_hint": "Aktywne kanały i konta firmy bez oferty tego produktu",
  "mpo.fam_brak_kanalow": "brak: {k}",
  "mpo.fam_w_zestawach": "w {n} zestawach · {o} ofert",
  "mpo.fam_w_zestawach_hint": "Oferty zestawów zawierających ten produkt",
  "mpo.fam_zestaw_wiersz": "przez zestaw: {nazwa}{krotnosc} · {n} ofert",
  "mpo.fam_zestaw_rozwin": "Rozwiń lub zwiń oferty zestawu",
  "mpo.fam_wylaczone": "wyłączone: {k}",
  "mpo.fam_wylaczone_hint": "Kanały świadomie wyłączone dla tego produktu — nie są traktowane jako brak",
  "mpo.fam_sold_30d": "ostatnie 30 dni: {n}",
  "mpo.fam_kandydat_hint": "Kandydat po {p}: {n} #{id}. Powiązanie zapisze się po Twoim potwierdzeniu.",
  "mpo.fam_kandydat_btn": "Powiąż {n} → {nazwa} #{id}",
  "mpo.fam_kandydat_why": "pasuje po {p}",
  "mpo.fam_n_zgodne": "{n} zgodne",
  "mpo.fam_n_bledne": "{n} błędne",
  "mpo.fam_n_do_potwierdzenia": "{n} do potwierdzenia",
  "mpo.fam_n_sku_nieznane": "{n} SKU nieznane",
  "mpo.fam_n_bez_sku": "{n} bez SKU",
  "mpo.fam_chk_aria": "Zaznacz ofertę do powiązania",
  "mpo.fam_fix_hint": "Otwiera szufladę powiązań tej oferty z gotowym wyborem. Zapis dopiero po „Zapisz powiązanie\". Nic nie idzie do marketplace.",
  "mpo.fam_fix_btn": "Popraw powiązanie → #{id}",
  "mpo.fam_qty_hint": "Otwiera szufladę z fokusem na polu krotności. Liczbę wpisujesz Ty.",
  "mpo.fam_qty_btn": "Ustaw krotność…",
  "mpo.fam_pw_zgodne": "SKU zgodne",
  "mpo.fam_pw_bledne": "SKU oferty ≠ SKU produktu",
  "mpo.fam_pw_nieznane_hint": "SKU oferty nie istnieje u żadnego produktu firmy — popraw kod u źródła (po stronie marketplace)",
  "mpo.fam_pw_nieznane": "SKU nieznane w katalogu",
  "mpo.fam_pw_bez_sku_ok": "bez SKU · EAN zgodny",
  "mpo.fam_pw_bez_sku_rozny": "bez SKU · EAN różny",
  "mpo.fam_n_ean_rozny": "{n} z cudzym EAN",
  "mpo.fam_rail_ean_rozny": "Cudzy EAN",
  "mpo.fam_pw_ean_rozny": "SKU zgodne · cudzy EAN",
  "mpo.fam_pw_mnoznik_hint": "Mnożnik linku: sprzedaż 1 szt. oferty = N szt. produktu",
  "mpo.fam_pw_krotnosc_konflikt": "krotność: tytuł {t}×, produkt {p}×, mnożnik {m}",
  "mpo.fam_pw_krotnosc": "krotność do potwierdzenia: tytuł {t}×, mnożnik {m}",
  "mpo.fam_proposal_fix": "Szuflada z gotowym wyborem — zapis dopiero po „Zapisz powiązanie\".",
  "mpo.fam_koszyk": "Bez produktu",
  "mpo.fam_koszyk_hint": "oferty bez powiązania, pogrupowane po EAN / SKU / tytule — tylko podpowiedź, powiązanie zawsze klikiem",
  "mpo.fam_koszyk_kandydaci": "{n} ma kandydata po SKU/EAN",
  "mpo.fam_koszyk_empty": "Wszystkie oferty mają produkt.",
  "mpo.fam_bulk_selected": "Zaznaczone oferty: {n}",
  "mpo.fam_bulk_btn": "Powiąż zaznaczone ({n})",
  "mpo.fam_bulk_clear": "Wyczyść",
  "mpo.fam_bulk_confirm": "{n} ofert zostanie powiązanych z produktem {p} #{id} (krotność ×{q}). Nic nie idzie do marketplace.",
  "mpo.fam_bulk_confirm_qty": "Uwaga: {n} ofert ma liczbę w tytule — krotność ustawisz potem w szufladzie oferty.",
  "mpo.fam_bulk_title": "Powiązać oferty?",
  "mpo.fam_bulk_done": "Powiązano {n} ofert",
  "mpo.fam_bulk_errors": "{n} błędów",
  "mpo.fam_pick_title": "Wybierz produkt",
  "mpo.fam_pick_title_n": "Wybierz produkt dla {n} ofert",
  "mpo.fam_pick_sub": "Jeden produkt dla wszystkich zaznaczonych. Zapis po potwierdzeniu.",
  "mpo.fam_pick_ph": "Szukaj: nazwa, SKU, EAN",
  "mpo.fam_pick_qty": "Krotność ×N (dla każdej oferty)",
  "mpo.fam_pick_empty": "Brak produktów",
  "mpo.fam_link_clean": "Powiązanie bez uwag",
  "mpo.fam_reszta_ofert": "Pokaż wszystkie oferty produktu (+{n} bez uwag)",
  "mpo.fam_reszta_ofert_wiecej": "Pokaż wszystkie oferty produktu (+{n}, w tym {m} z uwagą)",
  "mpo.fam_kod_powiazane": "Ten sam kod nosi też {n} ofert powiązanych z kartami {k} — to one blokują jedno pewne dopasowanie.",
  "mpo.fam_pw_dzis_hint": "Karta, z której oferta sprzedaje dziś",
  "mpo.fam_pw_dzis": "dziś #{id}",
  "mpo.fam_pw_powinno": "powinno być #{id}",
  "mpo.fam_pw_wielo": "Oferta ma kilka składników — popraw skład w szufladzie.",
  "mpo.fam_przepnij_hint": "Zapisuje przepięcie po potwierdzeniu: nowe sprzedaże zdejmą stan z nowej karty, stan zdjęty wcześniej zostaje. Nic nie idzie do marketplace.",
  "mpo.fam_przepnij_btn": "Przepnij → #{id}",
  "mpo.fam_przepnij_title": "Przepiąć ofertę na #{id}{sku}?",
  "mpo.fam_przepnij_tresc": "Oferta {mp} {oferta} przestanie sprzedawać z karty #{z} i zacznie z #{id}{nazwa}{q}. Stan zdjęty przez wcześniejsze sprzedaże zostaje na #{z}; nowe sprzedaże zdejmą stan z #{id}. Wpis trafi do historii obu kart. Nic nie idzie do marketplace.",
  "mpo.fam_przepnij_ok": "Przepnij",
  "mpo.fam_przepnij_done": "Przepięto ofertę {oferta} na #{id}",
  "mpo.fam_sub_product": "Produkt #{id}",
  "mpo.fam_sub_pien": "pień {p}",
  "mpo.fam_prod_offers": "Oferty",
  "mpo.fam_prod_offers_bad": "(w tym {n} błędnie)",
  "mpo.fam_prod_linked": "powiązany",
  "mpo.fam_prod_none": "brak",
  "mpo.fam_diag_today": "Dziś: {o} → #{id} {n}{kiedy}",
  "mpo.fam_diag_linked_at": "powiązano {d}",
  "mpo.fam_diag_target": "Cel: #{id} {n}{sku}",
  "mpo.fam_diag_bledne_h": "Błędne powiązanie oferty",
  "mpo.fam_diag_krotnosc_h": "Krotność do potwierdzenia",
  "mpo.fam_diag_kandydat_h": "Kandydat na powiązanie",
  "mpo.fam_offer_sold": "sprzedane {n}",
  "products.pnie_assign_group": "Przypisz do grupy",
  "products.pnie_candidates_loading": "Szukam kandydatów na bazę…",
  "products.pnie_children": "Zestawy",
  "products.pnie_children_n": "{n} produktów wskazuje ten jako bazę zestawu",
  "products.pnie_group": "Grupa",
  "products.pnie_group_cleared": "Grupa wraca do pnia z SKU",
  "products.pnie_group_from_base": "grupa z produktu bazowego #{id}",
  "products.pnie_group_from_sku": "z SKU",
  "products.pnie_group_manual": "ręcznie: {stem}",
  "products.pnie_group_none": "nietypowe SKU — bez pnia",
  "products.pnie_group_saved": "Grupa zapisana",
  "products.pnie_multiplier": "Krotność ×",
  "products.pnie_multiplier_hint": "w nazwie: {n} szt.",
  "products.pnie_no_candidates": "Brak kandydatów w tym pniu — wybierz „Inny produkt…”",
  "products.pnie_other_product": "Inny produkt…",
  "products.pnie_same_ean": "ten sam EAN",
  "products.pnie_section": "Grupa i krotność",
  "products.pnie_section_hint": "Grupa i oznaczenie zestawu wpływają TYLKO na grupowanie w Katalogu i Ofertach — nie na SKU, EAN ani stany.",
  "products.pnie_section_sub": "pień SKU, ręczna grupa, oznaczenie zestawu ×N",
  "products.tagi_label": "Tagi",
  "products.tagi_none": "brak tagów",
  "products.tagi_add": "tag",
  "products.tagi_add_placeholder": "Wybierz tag…",
  "products.tagi_removed": "Zdjęto tag",
  "products.tagi_added": "Dodano tag",
  "products.tagi_remove_title": "Zdejmij tag z tej karty",
  "products.tagi_manage_hint": "Nowe tagi tworzysz w Narzędzia → Tagi",
  "products.model_label": "Model",
  "products.model_split_info": "wydzielony ze SKU — własny model i pień",
  "products.model_undo": "Wróć do modelu ze SKU",
  "products.model_manual": "ręczne przypisanie",
  "products.model_from_sku": "z reguł SKU",
  "products.model_none": "bez modelu",
  "products.model_split": "Wydziel do osobnego modelu…",
  "products.model_family": "Gama",
  "products.model_code": "Oznaczenie modelu",
  "products.model_name": "Nazwa grupy (opcjonalnie)",
  "products.model_split_hint": "Inny towar pod tym samym pniem SKU: jeden zapis ustawi własny model w Katalogu i własny pień dla ofert oraz Porządku. Nie zmienia SKU, EAN, stanu ani powiązań.",
  "products.model_code_required": "Wpisz oznaczenie modelu",
  "products.model_split_saved": "Wydzielono do modelu {kod} — pień {pien}",
  "products.model_undo_title": "Wrócić do modelu ze SKU?",
  "products.model_undo_confirm": "Zdejmie ręczne miejsce w katalogu i ręczny pień. SKU, EAN, stan i powiązania bez zmian.",
  "products.model_undone": "Karta wróciła do modelu ze SKU",
  "products.pnie_set": "Zestaw",
  "products.pnie_set_base": "To jest ×N produktu:",
  "products.pnie_set_incomplete": "Wybierz produkt bazowy i wpisz krotność ≥ 2",
  "products.pnie_set_mark": "Oznacz jako zestaw…",
  "products.pnie_set_none": "nie oznaczono",
  "products.pnie_set_remove": "Usuń oznaczenie",
  "products.pnie_set_remove_title": "Usuń oznaczenie zestawu",
  "products.pnie_set_remove_confirm": "Usunąć oznaczenie zestawu? Produkt wróci do grupowania po własnym SKU.",
  "products.pnie_set_removed": "Oznaczenie zestawu usunięte",
  "products.pnie_set_saved": "Oznaczenie zestawu zapisane",
  "products.pnie_stem": "Pień",
  "products.pnie_stem_clear": "Wyczyść (wróć do SKU)",
  "products.pnie_stem_hint": "Podpowiedzi to istniejące pnie katalogu; wolny tekst jest dozwolony (2–40 znaków, wielkie litery).",
  "products.pnie_stem_placeholder": "np. HLX-0046 (litery, cyfry, &, -)",
  "products.porzadek_conf_high": "wysoka",
  "products.porzadek_conf_low": "niska",
  "products.porzadek_conf_mid": "średnia",
  "products.porzadek_confidence": "pewność",
  "products.porzadek_done": "Zrobione",
  "products.porzadek_empty": "Kolejka pusta",
  "products.porzadek_empty_sub": "Nic do decyzji w tej kolejce — nowe pozycje pojawią się po kolejnej synchronizacji ofert.",
  "products.porzadek_error": "Nie udało się wczytać kolejki",
  "products.porzadek_hint_candidate": "kandydat: {name} ({sku}) — {why}",
  "products.porzadek_hint_from_offers": "z {n} ofert",
  "products.porzadek_hint_gtin_bad": "EAN z oferty ma złą sumę kontrolną",
  "products.porzadek_hint_multiplier": "powiązanie: ×{n}",
  "products.porzadek_hint_offers_group": "grupa {n} ofert: {list}",
  "products.porzadek_hint_pack": "Allegro: zestaw ×{n}",
  "products.porzadek_hint_prices": "cena oferty {a} · produktu {b}",
  "products.porzadek_hint_product": "w nazwie produktu: {n}",
  "products.porzadek_hint_sku_pair": "SKU oferty {a} · SKU produktu {b}",
  "products.porzadek_hint_target": "cel: {name} ({sku}, #{id})",
  "products.porzadek_hint_title": "w tytule: {n}×",
  "products.porzadek_intended": "To celowe",
  "products.porzadek_intended_done": "Oznaczono jako celowe",
  "products.porzadek_intended_title": "Pozycja jest w porządku — zniknie z kolejki i rozliczy postęp; wróci, gdy propozycja się zmieni",
  "products.porzadek_linked_n": "Powiązano {n} ofert",
  "products.porzadek_loading": "Ładowanie kolejki…",
  "products.porzadek_mismatch": "tytuł nadal mówi {n}× — jeśli to celowe, kliknij »to celowe«",
  "products.porzadek_n_items": "{n} pozycji",
  "products.porzadek_no_drawer": "Szuflada powiązania niedostępna",
  "products.porzadek_no_image": "Brak zdjęcia",
  "products.porzadek_no_offer": "Pozycja nie ma oferty do otwarcia",
  "products.porzadek_open_offer": "otwórz ofertę",
  "products.porzadek_pick_image": "Wybierz zdjęcie",
  "products.porzadek_pick_none": "Brak produktów",
  "products.porzadek_pick_placeholder": "Szukaj produktu (nazwa, SKU, EAN)…",
  "products.porzadek_pick_target": "Zaznacz produkt DOCELOWY (ten zostaje)",
  "products.porzadek_pill_all": "Wszystkie",
  "products.porzadek_pill_confirmed": "Potwierdzone",
  "products.porzadek_pill_skipped": "Pominięte",
  "products.porzadek_qty": "Krotność ×",
  "products.porzadek_qty_aria": "Krotność powiązania — wpisz liczbę",
  "products.porzadek_qty_required": "Wpisz krotność (liczba ≥ 1)",
  "products.porzadek_restart": "Zacznij liczyć od nowa",
  "products.porzadek_restart_title": "Liczyć postęp od nowa?",
  "products.porzadek_restart_confirm": "Pasek „załatwione” wystartuje od bieżącego stanu kolejek.",
  "products.porzadek_restart_done": "Baza postępu zamrożona od nowa",
  "products.porzadek_restore": "Przywróć",
  "products.porzadek_restored": "Przywrócono do kolejki",
  "products.porzadek_saved": "Zapisano",
  "products.porzadek_shown": "Pokazano {from}–{to} z {total}",
  "products.porzadek_shown_hint": "po potwierdzeniu karta znika, licznik w pasku maleje",
  "products.porzadek_skip": "Pomiń",
  "products.porzadek_skip_done": "Pominięto",
  "products.porzadek_skip_title": "Schowaj na później — nie rozlicza postępu, widać w „Pominięte”",
  "products.porzadek_sort": "Sortuj",
  "products.porzadek_sort_id": "po identyfikatorze",
  "products.porzadek_sort_newest": "najnowsze oferty",
  "products.porzadek_sort_pewnosc": "pewność: od najwyższej",
  "products.porzadek_stock": "stan {n}",
  "products.porzadek_undo": "Cofnij",
  "products.porzadek_unknown_action": "Nieznana akcja — odśwież stronę",
  "products.porzadek_kind_kod_z_oferty": "Uzupełnij kod z oferty",
  "products.porzadek_kind_bez_produktu": "Bez produktu",
  "products.porzadek_kind_bledne_powiazanie": "Błędne powiązanie",
  "products.porzadek_kind_krotnosc": "Krotność ofert",
  "products.porzadek_kind_ean": "Ten sam EAN",
  "products.porzadek_kind_sku": "Duplikat SKU",
  "products.porzadek_kind_wariant_bez_oferty": "Do wystawienia",
  "products.porzadek_kind_sku_poza_wzorcem": "SKU poza wzorcem",
  "products.porzadek_opis_kod_z_oferty": "Produkt bez EAN / SKU / zdjęcia, którego wszystkie oferty niosą jeden kod. Wartość pochodzi z podpiętych ofert — kliknięcie ją zapisuje.",
  "products.porzadek_opis_bez_produktu": "Oferty bez powiązanego produktu, zgrupowane po kodzie. Kandydat to tylko podpowiedź — powiązanie powstaje po kliknięciu.",
  "products.porzadek_opis_bledne_powiazanie": "SKU oferty wskazuje inny produkt niż ten, do którego jest podpięta. Wybierz kartę i krotność, zapis po potwierdzeniu; stan zdjęty wcześniej zostaje na dotychczasowej karcie.",
  "products.porzadek_opis_krotnosc": "Liczba w tytule oferty nie zgadza się z mnożnikiem powiązania. Pole ×N wypełnia podpowiedź z Allegro albo tytułu — sprawdź i zapisz albo popraw.",
  "products.porzadek_opis_ean": "Dwa lub więcej produktów z tym samym EAN, ale różnym SKU. Inny SKU to inny produkt: albo EAN jest błędny u jednego, albo to sztuka i zestaw, albo ta sama rzecz wpisana dwa razy — decyduje człowiek po podglądzie.",
  "products.porzadek_opis_sku": "Produkty zapisane pod tym samym SKU w różnej notacji. Ten sam SKU to ten sam produkt — scalenie po podglądzie wpływu; stany nie są sumowane.",
  "products.porzadek_opis_wariant_bez_oferty": "Produkt z grupy, którego rodzeństwo ma aktywne oferty, a on sam nie ma żadnej. Wystawianie z produktu działa na Von Halsky i TikTok; pozostałe kanały przez Poczekalnię.",
  "products.porzadek_opis_sku_poza_wzorcem": "SKU, z którego nie da się odczytać pnia grupy. Kandydatów podpowiada EAN, kod lub litery SKU — nigdy nazwa; pień wybiera albo wpisuje pracownik.",
  "products.porzadek_kind_kod_u_zrodla": "Kod u źródła",
  "products.porzadek_opis_kod_u_zrodla": "Aktywna oferta bez SKU albo bez EAN. Kod wpisuje człowiek w panelu kanału — SellBase nie zapisuje niczego do marketplace’u; po najbliższej synchronizacji pozycja znika z kolejki sama.",
  "products.porzadek_opis_set_bez_skladu": "Karta -SET zapisana jako zwykły produkt. W SellBase -SET to zestaw ze składem N × baza (SKU bez -SET) — pozycja podpowiada bazę i krotność z SKU lub nazwy, krotność potwierdza człowiek, zapis przechodzi przez podgląd zestawów. Zestawy z importu p4u/Sellasist bez składu też tu trafiają (stan z dnia importu jest fikcyjny); przy ofercie podpiętej ×k najpierw ustaw ×1.",
  "products.porzadek_opis_zdjecia_do_odzyskania": "Zdjęcia karty siedzą pod martwymi adresami (wygasły upload Allegro, cudzy CDN) i nie dało się ich skopiować. „Pobierz z oferty” bierze zdjęcia z żywej oferty karty do SellBase; bez oferty wgraj je ręcznie w karcie.",
  "products.porzadek_kind_zdjecia_do_odzyskania": "Zdjęcia do odzyskania",
  "products.porzadek_kind_set_bez_skladu": "Zestaw -SET bez składu",
  "products.porzadek_opis_ean_oferty": "Oferta powiązana po zgodnym SKU, ale z innym EAN niż karta — kupujący widzi cudzy kod, a automat po EAN przepinał sprzedaż na cudzą kartę. EAN poprawia człowiek u źródła (SellBase nie zapisuje do marketplace’u); „Przepnij” tylko gdy oferta naprawdę sprzedaje towar z tego EAN. Zestaw i wariant mają własny EAN — współdzielony nigdy nie jest celowy.",
  "products.porzadek_kind_ean_oferty": "EAN oferty ≠ produktu",
  "products.porzadek_e5_open_source": "Otwórz ofertę w kanale",
  "products.porzadek_e5_no_link": "Kanał nie udostępnia linku do oferty — skopiuj ID i wyszukaj ofertę w panelu kanału",
  "products.porzadek_e5_kopiuj_id": "Kopiuj ID oferty",
  "products.porzadek_e5_id_skopiowane": "Skopiowano ID oferty: {id}",
  "products.porzadek_e5_kopiuj_blad": "Nie udało się skopiować — zaznacz ID ręcznie",
  "products.porzadek_e5_export_csv": "Pobierz CSV",
  "products.porzadek_e5_export_err": "Nie udało się pobrać CSV",
  "products.porzadek_e5_account_all": "Wszystkie konta",
  "products.porzadek_e5_missing": "brakuje: {list}",
  "products.porzadek_e6_qty_hint": "podpowiedź: {n}×",
  "products.porzadek_e6_dead_no_offer": "brak żywej oferty ze zdjęciami — wgraj ręcznie",
  "products.porzadek_e6_dead_has_offer": "żywa oferta ze zdjęciami jest — można pobrać",
  "products.porzadek_e6_dead_images": "martwe adresy: {n} (np. {u})",
  "products.porzadek_e6_names_differ": "nazwy wskazują co innego — to raczej dwa różne towary pod jednym kodem",
  "products.porzadek_e6_confirm_title": "Przepiąć ofertę?",
  "products.porzadek_e6_preview_invalid": "Skład zestawu nie przeszedł podglądu — popraw go w karcie produktu",
  "products.porzadek_e6_from_text": "z nazwy lub tytułu oferty",
  "products.porzadek_e6_from_suffix": "z sufiksu SKU",
  "products.porzadek_e6_set_qty": "krotność {n} ({src})",
  "products.porzadek_e6_set_nobase": "brak karty bazowej w katalogu",
  "products.porzadek_e6_set_base": "baza: {sku} — {name}",
  "products.porzadek_e6_ean_only_offer": "EAN nie występuje na żadnej innej karcie ani ofercie — najpewniej ponowne wystawienie z nowym kodem",
  "products.porzadek_e7_ocena_all": "Wszystkie stany",
  "products.porzadek_e7_ocena_safe": "Bezpieczne · EAN tylko tej oferty",
  "products.porzadek_e7_ocena_other": "Na innej ofercie bez karty",
  "products.porzadek_e7_ocena_conflict": "Konflikt",
  "products.porzadek_e7_ocena_unknown": "Nie sprawdzono",
  "products.porzadek_e7_alias_all": "Dodaj wszystkie bezpieczne jako dodatkowe EAN ({n})",
  "products.porzadek_e7_alias_all_hint": "Najpierw podgląd: ile wejdzie, ile pominę. Główne EAN bez zmian, zero zapisów do marketplace.",
  "products.porzadek_e7_alias_none": "Nic do dodania — bezpieczne przypadki są już przyjęte",
  "products.porzadek_e7_confirm_title": "Dodać {n} dodatkowych EAN?",
  "products.porzadek_e7_confirm": "Dodam {n} dodatkowych EAN (tylko „EAN tylko tej oferty”). Pominę: {k} konfliktów, {i} na innych ofertach, {z} błędnych GTIN, {u} niesprawdzonych. Główne EAN kart bez zmian, zero zapisów do marketplace; każdy alias ma krzyżyk w karcie.",
  "products.porzadek_e7_done": "Dodano {n} dodatkowych EAN, pominięto {m}",
  "products.porzadek_e6_ean_other_offers": "EAN nosi też inna oferta bez karty: {list}",
  "products.porzadek_e6_alias_add": "+ dodaj jako dodatkowy EAN produktu",
  "products.porzadek_e6_ean_nobody": "EAN nie należy do żadnej karty w katalogu",
  "products.porzadek_e6_ean_owner": "EAN należy do: {list}",
  "products.porzadek_e6_ean_pair": "EAN oferty {a} · EAN karty {b}",
  "products.porzadek_e4_channel_unknown": "Kanał {k} nie ma wystawiania z produktu — otwórz kartę produktu",
  "products.porzadek_e4_listing_unavailable": "Modal wystawiania niedostępny",
  "products.porzadek_e4_merged": "Scalono — pozycja rozliczona",
  "products.porzadek_e4_missing": "brak: {list}",
  "products.porzadek_e4_no_candidates": "brak kandydatów — wpisz pień ręcznie",
  "products.porzadek_e4_no_product": "Pozycja nie ma produktu do otwarcia",
  "products.porzadek_e4_offers": "{n} ofert",
  "products.porzadek_e4_open_card": "karta produktu",
  "products.porzadek_e4_p4u": "link p4u",
  "products.porzadek_e4_proposed": "proponowany cel",
  "products.porzadek_e4_reason_ean": "ten sam EAN",
  "products.porzadek_e4_reason_kod": "kod SKU",
  "products.porzadek_e4_reason_litery": "litery",
  "products.porzadek_e4_reason_n": "{n} prod.",
  "products.porzadek_e4_sales180": "sprzedaż 180 d: {n}",
  "products.porzadek_e4_siblings": "rodzeństwo: {list}",
  "products.porzadek_e4_stem_aria": "Kandydaci pnia grupy",
  "products.porzadek_e4_stem_input_aria": "Pień grupy — wybierz kandydata albo wpisz",
  "products.porzadek_e4_stem_label": "Pień grupy",
  "products.porzadek_e4_stem_of": "pień {p}",
  "products.porzadek_e4_stem_placeholder": "np. HLX-0046",
  "products.porzadek_e4_stem_required": "Wybierz albo wpisz pień grupy",
  "products.porzadek_e4_target_aria": "Produkt docelowy — ten zostaje po scaleniu",
  "products.porzadek_e4_which": "U którego produktu poprawić EAN?",
  "products.scal_ack": "Rozumiem: atrybucja sprzedaży źródeł zostanie przepięta NIEODWRACALNIE, stanów nie sumujemy (stan po scaleniu jak wybrano wyżej, zmiana w historii ruchów), faktury i dokumenty pozostają nietknięte.",
  "products.scal_after": "Źródła trafią do archiwum z odnośnikiem do przeżywającego; wyszukiwanie po dawnych SKU/EAN otworzy produkt docelowy. Cofanie scaleń — osobna decyzja (poza E4).",
  "products.scal_back": "Wstecz",
  "products.scal_badge_archived": "do archiwum",
  "products.scal_badge_source": "źródło",
  "products.scal_badge_target": "zostaje",
  "products.scal_base_none": "Bez zmiany",
  "products.scal_base_none_sub": "oferta bazowa przeżywającego zostaje, jaka jest",
  "products.scal_base_offer": "Oferta bazowa (opcjonalnie)",
  "products.scal_base_offer_sub": "Referencyjna oferta do przyszłej edycji treści. Domyślnie bez zmiany — można też wybrać później w karcie produktu.",
  "products.scal_blocked": "Blokada:",
  "products.scal_blocked_next": "Blokada — najpierw usuń przyczynę z listy wyżej",
  "products.scal_chip_base": "bazowa",
  "products.scal_chip_ean": "ma EAN",
  "products.scal_chip_offers": "{n} ofert",
  "products.scal_chip_p4u": "link p4u",
  "products.scal_chip_proposed": "proponowany",
  "products.scal_chip_sales180": "sprzedaż 180 d: {n}",
  "products.scal_col_custom": "Pola własne",
  "products.scal_col_mirrors": "Lustra",
  "products.scal_col_notes": "Notatki",
  "products.scal_col_offers": "Oferty (aktywne · kanały, konta)",
  "products.scal_col_product": "Produkt",
  "products.scal_col_sales": "Sprzedaż 90 / 180 d",
  "products.scal_col_stock": "Stan",
  "products.scal_col_tags": "Tagi",
  "products.scal_done": "Scalono {n} · przeniesiono: {list}",
  "products.scal_drawer_btn": "Scal z innym…",
  "products.scal_older_title": "To nie duplikat, tylko starszy model?",
  "products.scal_older_sub": "Zamiast scalać, podepnij pozostałe karty jako STARSZE WERSJE zaznaczonego. Oba produkty zostają osobno (oferty, stan, koszt, historia); starszy znika tylko z ogólnej listy Katalogu i pokazuje się pod nowszym.",
  "products.scal_older_btn": "Podepnij {n} jako starsze wersje zaznaczonej #{id} (ta zostaje aktualna)",
  "products.scal_older_failed": "Nie udało się oznaczyć starszej wersji",
  "products.scal_older_done": "Oznaczono {n} jako starsze wersje #{id} — znikną z ogólnej listy, zostaną pod nowszym",
  "products.wersje_label": "Wersje",
  "products.wersje_starsza_of": "starsza wersja produktu",
  "products.wersje_open_newer": "Otwórz nowszy",
  "products.wersje_detach": "Odepnij",
  "products.wersje_packs": "{n} paczek ×N",
  "products.wersje_stats": "stan {q}, sprzedaż 30 d: {s}",
  "products.wersje_has_older": "ma starsze wersje: {n}",
  "products.wersje_none": "brak starszych wersji",
  "products.wersje_mark": "Oznacz jako starszą wersję…",
  "products.wersje_add_older": "Podepnij starszą…",
  "products.wersje_pick_newer": "Ten produkt jest starszą wersją…",
  "products.wersje_pick_older": "Podepnij starszą wersję tego produktu…",
  "products.wersje_pick_hint": "To nie scalanie: oba produkty zostają osobnymi kartami z własnymi ofertami, stanem i historią. Starszy znika tylko z ogólnej listy Katalogu i pokazuje się pod nowszym.",
  "products.wersje_marked": "Oznaczono jako starszą wersję",
  "products.wersje_marked_via": "Oznaczono jako starszą wersję #{id} — wskazany produkt sam był starszą wersją, relacja poszła pod jego następcę",
  "products.wersje_detach_title": "Odpiąć starszą wersję?",
  "products.wersje_detach_confirm": "Karta wróci na ogólną listę Katalogu. Oferty, stan i historia obu produktów zostają bez zmian.",
  "products.wersje_detached": "Odpięto starszą wersję — karta wróciła na listę",
  "products.wersje_banner": "To starsza wersja produktu {name} ({sku}). Aktualny model ma osobną kartę — tam wystawiaj nowe oferty.",
  "products.wersje_pz_title": "To nie duplikat, tylko starszy model: pozostałe karty staną się starszymi wersjami zaznaczonego celu — bez scalania",
  "products.wersje_pz_btn": "Starsza wersja → zaznaczony…",
  "products.wersje_pz_confirm_title": "Oznaczyć jako starsze wersje?",
  "products.wersje_pz_confirm": "{n} kart stanie się starszymi wersjami #{id}. To nie scalanie: oferty, stan i historia każdej karty zostają, starsze znikną tylko z ogólnej listy Katalogu.",
  "products.wersje_pz_done": "Oznaczono {n} jako starsze wersje #{id} — grupa zniknie z duplikatów",
  "products.scal_failed": "Nie udało się scalić",
  "products.scal_inactive": "nieakt.",
  "products.scal_k1": "Który zostaje",
  "products.scal_k2": "Podgląd wpływu",
  "products.scal_k3": "Wykonanie",
  "products.scal_loading": "Wczytuję podgląd scalenia…",
  "products.scal_moved_atrybucja_sprzedazy": "wierszy atrybucji sprzedaży",
  "products.scal_moved_links": "powiązań",
  "products.scal_moved_lustra": "luster kanałów",
  "products.scal_moved_none": "Poza ofertami nic do przeniesienia.",
  "products.scal_moved_notatki": "notatek",
  "products.scal_moved_oferty": "ofert",
  "products.scal_moved_p4u": "link p4u",
  "products.scal_moved_pien_reczny": "ręczny pień",
  "products.scal_moved_pola_wlasne": "pól własnych",
  "products.scal_moved_propozycje": "propozycji powiązań",
  "products.scal_moved_szkice_poczekalni": "szkiców Poczekalni",
  "products.scal_moved_tagi": "tagów",
  "products.scal_moved_title": "Zostanie przeniesione",
  "products.scal_moved_vat": "VAT",
  "products.scal_moved_wyjatki_kanalow": "wyjątków kanałów",
  "products.scal_moved_zestawy_wskazujace": "zestawów wskazujących źródło",
  "products.scal_name_exists": "Istnieje produkt o tej nazwie: SKU {sku} (#{id}). Ten sam SKU = ten sam produkt; inna rzecz = inny SKU.",
  "products.scal_need_two": "Zaznacz co najmniej dwa produkty do scalenia",
  "products.scal_next": "Dalej",
  "products.scal_no_api": "Brak połączenia z API",
  "products.scal_no_offers": "Produkt nie ma powiązanych ofert",
  "products.scal_not_moved_title": "NIE zostanie przeniesione",
  "products.scal_offers_loading": "Wczytuję oferty…",
  "products.scal_offers_none": "Te produkty nie mają ofert marketplace.",
  "products.scal_pick_none": "Brak produktów",
  "products.scal_pick_placeholder": "Szukaj produktu (nazwa, SKU, EAN)…",
  "products.scal_pick_title": "Scal ten produkt z…",
  "products.scal_preview_error": "Nie udało się przeliczyć podglądu",
  "products.scal_preview_failed": "Nie udało się przygotować scalenia",
  "products.scal_preview_shape": "Podgląd scalenia ma nieznany kształt",
  "products.scal_refresh": "Odśwież podgląd",
  "products.scal_reserved_text": "zarezerwowane {n}",
  "products.scal_stem": "pień",
  "products.scal_step1_sub": "Przeżywający zachowuje swoje dane, stan i identyfikator. Propozycja: ma EAN › ma link p4u › najwięcej ofert › najniższe id — możesz ją zmienić.",
  "products.scal_step1_title": "Który produkt zostaje?",
  "products.scal_step2_sub": "Liczby policzone względem wybranego przeżywającego. Stan jest tylko informacją — nie jest kryterium.",
  "products.scal_step2_title": "Podgląd wpływu — {n} produkty → #{id}",
  "products.scal_step3_title": "Wykonanie",
  "products.scal_steps_aria": "Kroki kreatora",
  "products.scal_stock_rule": "Stan po scaleniu wybierasz w sekcji wyżej (domyślnie stan przeżywającego); stany źródeł zostają tylko w historii.",
  "products.scal_stock_text": "stan {n}",
  "products.scal_sub": "Jeden produkt zostaje; oferty, notatki, tagi i historia przechodzą do niego. Nic nie dzieje się przed krokiem 3.",
  "products.scal_submit": "Scal {n} → #{id}",
  "products.scal_title": "Scal {n} produkty",
  "channels.confirm_anyway": "Mimo to",
  "channels.confirm_anyway_title": "Potwierdzić „mimo to”?",
  "channels.confirm_anyway_body": "Kody z paczki i z produktu się różnią. Wysłać do kanału mimo to? Decyzja zostanie zapisana w historii.",
  "channels.mismatch_title": "Paczka i produkt się różnią",
  "channels.col_field": "Pole",
  "channels.col_package": "Paczka",
  "channels.col_product": "Produkt",
  "channels.sku_exists_title": "Istnieje już produkt o tym SKU",
  "channels.ean_exists_title": "Istnieje już produkt o tym EAN",
  "channels.sku_exists_hard": "Ten sam SKU = ten sam produkt — edytuj istniejący albo nadaj inny SKU.",
  "channels.sku_exists_body": "Ten sam SKU = ten sam produkt. Zapisać drugi produkt pod tym SKU mimo to? Decyzja trafi do audytu i wyciszy tę parę w „Możliwych duplikatach”.",
  "channels.fill_sku": "Uzupełnij SKU w karcie produktu",
  "channels.open_product": "Otwórz kartę produktu",
  "channels.open": "Otwórz",
  "channels.change_product": "Powiąż inny produkt",
  "channels.bind_anyway": "Powiąż mimo to",
  "channels.publish_anyway": "Wystaw mimo to",
  "channels.readonly_from_product": "z produktu — zmień w karcie produktu",
  "channels.ean_checksum_warn": "EAN produktu ma złą sumę kontrolną — popraw w karcie produktu, VH nie pozwoli go zmienić po wystawieniu.",
  "channels.fix_errors": "Popraw błędy:",
  "channels.err_generic": "Nie udało się wystawić oferty.",
  "channels.pick_catalog_title": "Wybierz produkt katalogowy Allegro",
  "channels.pick_catalog_button": "Wybierz produkt katalogowy",
  "channels.pick_catalog_use": "Użyj",
  "channels.pick_catalog_hint": "Pod EAN {ean} Allegro ma {n} produktów katalogowych — oferta zostanie podpięta do wybranego. Wybór dotyczy tylko tej publikacji na tym koncie.",
  "channels.pick_catalog_empty": "Brak kandydatów do wyboru.",
  "channels.sku_shape_prefix": "Uwaga, SKU",
  "channels.sku_shape_spaces": "zawiera spacje lub białe znaki",
  "channels.sku_shape_long": "ma {n} znaków (limit 50)",
  "channels.sku_shape_amp": "zawiera „&” — marketplace’y bywają na to wrażliwe",
  "channels.tiktok_listing_title": "Wystaw na TikTok Shop",
  "channels.tiktok_listing_product": "Produkt",
  "channels.tiktok_listing_account": "Konto TikTok",
  "channels.tiktok_listing_pick_account": "— wybierz konto —",
  "channels.tiktok_listing_no_accounts": "Brak połączonych kont TikTok",
  "channels.tiktok_listing_data": "Dane oferty",
  "channels.tiktok_listing_name": "Tytuł",
  "channels.tiktok_listing_desc": "Opis",
  "channels.tiktok_listing_category": "Kategoria TikTok (id)",
  "channels.tiktok_listing_category_hint": "Wpisz id albo wybierz z podpowiedzi — kategorie liściowe z konta (ładowane po wyborze konta).",
  "channels.tiktok_listing_sku": "SKU",
  "channels.tiktok_listing_ean": "EAN",
  "channels.tiktok_listing_price": "Cena brutto (PLN)",
  "channels.tiktok_listing_qty": "Ilość (szt.)",
  "channels.tiktok_listing_qty_hint": "Wpisz świadomie — bez podpowiedzi ze stanu SellBase (stany odłożone).",
  "channels.tiktok_listing_mode": "Tryb zapisu",
  "channels.tiktok_listing_mode_draft": "Szkic (AS_DRAFT)",
  "channels.tiktok_listing_mode_listing": "Wystaw (LISTING)",
  "channels.tiktok_listing_images_title": "Zdjęcia",
  "channels.tiktok_listing_images": "Adresy URL zdjęć (po jednym w linii, pierwsze = główne)",
  "channels.tiktok_listing_submit": "Wystaw",
  "channels.tiktok_listing_sending": "Wysyłanie…",
  "channels.tiktok_listing_success": "Produkt TikTok utworzony",
  "channels.tiktok_listing_link_error": "Oferta utworzona, ale nie udało się powiązać z produktem: {error}",
  "channels.tiktok_listing_confirm_title": "Wysłać do TikTok Shop?",
  "channels.tiktok_listing_confirm": "Produkt „{title}” zostanie wysłany do TikTok Shop na konto {account} (tryb {mode}).",
  "channels.tiktok_listing_err_account": "Wybierz konto TikTok.",
  "channels.tiktok_listing_err_title": "Podaj tytuł.",
  "channels.tiktok_listing_err_desc": "Podaj opis.",
  "channels.tiktok_listing_err_category": "Podaj kategorię TikTok.",
  "channels.tiktok_listing_err_price": "Podaj poprawną cenę brutto (większą od 0).",
  "channels.tiktok_listing_err_qty": "Podaj ilość (liczba całkowita ≥ 0).",
  "channels.tiktok_listing_err_image": "Zdjęcie #{n}: adres musi zaczynać się od http(s)://",
  "products.scal_similar_open": "Karta produktu",
  "products.scal_similar_in_porzadek": "ta para jest w Porządku → Ten sam EAN",
  "products.scal_similar_summary": "Kandydaci z drugim sygnałem: ten sam EAN, ta sama miniaturka lub identyczne SKU — nazwa sama nie wystarcza. Nic nie jest scalane automatycznie.",
  "packing.scan_placeholder": "Zeskanuj SKU lub EAN",
  "packing.scan_choice_title": "Która pozycja? Kliknij albo wciśnij cyfrę",
  "packing.scan_confirmed": "Pozycja potwierdzona: {sku}{name}",
  "packing.scan_no_match": "Kod „{kod}” nie pasuje do żadnej niezebranej pozycji",
  "packing.scan_hit_product": "po kodzie produktu",
  "packing.scan_hit_offer": "po kodzie oferty",
  "mpo.fam_search_label": "Szukaj produktów i ofert",
  "mpo.fam_list_help": "Strzałka rozwija oferty · Kliknięcie produktu otwiera szczegóły",
  "mpo.fam_scroll_hint": "Przewiń tabelę w bok, aby zobaczyć pozostałe kolumny.",
  "mpo.fam_price_from": "od",
  "mpo.fam_price_to": "do",
  "mpo.fam_signal_price_short": "Cena do sprawdzenia · {n} ofert",
  "mpo.fam_signal_duplicates_short": "Możliwe duplikaty · {n} ofert",
  "mpo.fam_expand_offers": "Rozwiń lub zwiń oferty",
  "mpo.fam_page_products": "{od}–{do} z {total} produktów",
  "mpo.fam_page_groups": "{od}–{do} z {total} grup bez produktu",
  "mpo.page_limit": "Limit na stronę: {n}",
  "mpo.page_navigation": "Strony wyników",
  "mpo.page_first": "Pierwsza strona",
  "mpo.page_last": "Ostatnia strona",
  "mpo.page_previous": "Poprzednia",
  "mpo.page_next": "Następna",
  "invoices.sale_doc_exists.title": "Zamówienie ma już dokument sprzedaży",
  "invoices.sale_doc_exists.body": "Istniejący dokument: {docs}. Kolejny dokument sprzedaży do tego zamówienia wymaga podania powodu (min. {min} znaków) — trafi do historii dokumentu. Wiążąca jest faktura w wFirma.",
  "invoices.sale_doc_exists.draft": "szkic #{id}",
  "invoices.sale_doc_exists.reason_label": "Powód kolejnego dokumentu",
  "invoices.sale_doc_exists.reason_placeholder": "np. korekta do zera KOR/… — błędny NIP nabywcy",
  "invoices.sale_doc_exists.reason_too_short": "Podaj co najmniej {min} znaków",
  "invoices.sale_doc_exists.ok": "Wystaw kolejny dokument",
  "invoices.history.additional_sale_document": "Kolejny dokument sprzedaży (powód)",
  "invoices.history.changed_after_dispatch": "Zmieniono po wysłaniu do wFirma/KSeF (tylko w SellBase, faktura wiążąca bez zmian)",
  "invoices.automation.title": "Automat dokumentów sprzedaży",
  "invoices.automation.description": "Automat nie wystawi faktury/OSS/WDT dla zamówień wysłanych przed tą datą (liczy się pierwsza wysyłka; bez śladu wysyłki — data złożenia). Zmiana nie wystawia niczego wstecz.",
  "invoices.automation.from_label": "Obejmuje zamówienia wysłane od",
  "invoices.automation.save": "Zapisz",
  "invoices.automation.clear": "Wyczyść",
  "invoices.automation.saved": "Zapisano próg automatu — działa dla zdarzeń od teraz",
  "invoices.automation.save_error": "Nie zapisano: {error}",
  "invoices.automation.load_error": "Nie udało się wczytać: {error}",
  "invoices.automation.transition": "Okres przejścia: {n} zamówień wysłanych przed progiem bez dokumentu SellBase — dokumentuje poprzedni system.",
  "invoices.automation.to_check": "Do sprawdzenia: {n} zamówień wysłanych po progu bez dokumentu.",
  "invoices.automation.orders_link": "Pokaż na liście zamówień",
  "invoices.automation.no_threshold": "Brak progu — rozstrzygają wyłącznie warunki reguł.",
  "invoices.automation.rules_with_date": "Reguły dokumentowe z własnym warunkiem daty złożenia (informacyjnie — nie zmieniamy ich):",
  "invoices.automation.rules_none": "Żadna reguła dokumentowa nie ma własnego warunku daty.",
  "automations.retro_blocked_documents": "Reguły wystawiające dokumenty działają tylko dla nowych zdarzeń — wykonanie wstecz jest wyłączone.",
  "automations.saved_document_rule": "Reguła wystawia dokumenty, więc działa tylko dla nowych zdarzeń (bez wykonania wstecz).",
  "automations.cond_current_status": "Status zamówienia — bieżący",
  "automations.cond_status_event_hint": "Dla wyzwalacza „zmiana statusu” w regułach wystawiających dokumenty to status, na który zamówienie właśnie przeszło.",
  "orders.bulk_delete_has_documents": "{n} zamówień ma dokumenty sprzedaży — nie usunięto",
  "invoices.sale_draft_exists.title": "Zamówienie ma szkic dokumentu sprzedaży",
  "invoices.sale_draft_exists.body": "Wystaw albo usuń szkic {docs} — kolejnego dokumentu obok szkicu nie wystawiamy.",
  "invoices.buyer.company_without_tax_id": "Nabywca oznaczony jako firma nie ma NIP ani numeru VAT-UE — dokument zostanie zapisany jako szkic do sprawdzenia",
  "invoices.draft_saved": "Zapisano szkic: {reason}",
  "invoices.draft_saved_generic": "Zapisano szkic do sprawdzenia",
  "invoices.form.company_without_tax_id_hint": "Firma bez NIP i numeru VAT-UE — faktura zostanie zapisana jako szkic. Odznacz „Firma”, jeśli to osoba prywatna.",
  "orders.timeline.invoice_data_changed": "Dane do faktury zmienione",
  "orders.timeline.invoice_data_nip": "NIP",
  "orders.timeline.invoice_data_company": "firma",
  "orders.timeline.invoice_data_none": "brak",
  "orders.timeline.invoice_data_src_resync": "synchronizacja Allegro",
  "orders.timeline.invoice_data_src_before_issue": "odczyt przed wystawieniem",
  "orders.timeline.invoice_data_src_event": "zdarzenie Allegro",
  "invoices.engine.needs_attention": "Wymaga uwagi (wFirma/KSeF)",
  "invoices.engine.panel_title": "Dokumenty wymagające uwagi",
  "invoices.engine.empty": "Brak dokumentów wymagających uwagi",
  "invoices.engine.since": "od",
  "invoices.engine.open": "Otwórz",
  "invoices.engine.hide": "Ukryj",
  "invoices.engine.filtr_uwagi": "Pokazuję tylko dokumenty wymagające uwagi (wFirma/KSeF)",
  "invoices.engine.pokaz_wszystkie": "Pokaż wszystkie dokumenty",
  "invoices.engine.brak_uwagi": "Brak pozycji wymagających uwagi",
  "invoices.engine.kind.KOREKTA_CZEKA_NA_KSEF_B2C": "Korekta faktury z numerem KSeF dla osoby fizycznej czeka na „Dosłanie korekt do KSeF” (Ustawienia → wFirma)",
  "invoices.engine.kind.KSEF_B2C_NIEZGODNE": "Faktura dla osoby fizycznej trafiła do KSeF, choć w SellBase ustawione „poza KSeF” — wyłącz w wFirma wysyłkę faktur B2C do KSeF",
  "invoices.engine.kind.B2C_BEZ_KSEF": "Faktura dla osoby fizycznej bez numeru KSeF ponad 24 h, choć w SellBase ustawione „do KSeF” — włącz w wFirma wysyłkę faktur B2C do KSeF",
  "invoices.engine.kind.KOREKTA_B2C_POZA_KSEF_PRZEKAZANA": "Korekta faktury z numerem KSeF poszła poza KSeF i trafiła już do kupującego — zostaje poza KSeF (dokument skuteczny)",
  "invoices.engine.ksef_b2c": "Dosłanie do KSeF →",
  "invoices.wfirma.status.CZEKA_OKNO_KSEF": "Czeka na dosłanie do KSeF",
  "invoices.engine.kind.ERROR_WALIDACJI": "wFirma odrzuciła dokument (błąd walidacji) — popraw dane i wyślij ponownie",
  "invoices.engine.kind.CZEKA_W_KOLEJCE": "Czeka w kolejce do wFirma ponad 2 h albo wyczerpał próby",
  "invoices.engine.kind.WYNIK_NIEUSTALONY": "Wynik wysyłki do wFirma nieustalony — sprawdź w panelu wFirma i uzgodnij",
  "invoices.engine.kind.B2B_BEZ_KSEF": "Faktura B2B/WDT w wFirma bez numeru KSeF ponad 24 h",
  "invoices.engine.kind.KSEF_ODRZUCONA": "KSeF odrzucił fakturę (zgłoszone przez wFirma)",
  "invoices.engine.kind.KOREKTA_KSEF_BEZ_NUMERU": "Korekta faktury z numerem KSeF sama nie ma numeru KSeF ponad 2 h",
  "invoices.engine.kind.BEZ_FAKTURY_W_WFIRMA": "Numer SellBase nadany, faktury w wFirma jeszcze nie ma",
  "invoices.engine.kind.CZEKA_NA_RECZNA_WYSYLKE": "Automatyczna wysyłka wyłączona — czeka na przycisk „Wyślij do wFirma”",
  "invoices.engine.kind.PO_TERMINIE": "Data wystawienia po terminie (15. dzień miesiąca po miesiącu sprzedaży)",
  "invoices.engine.kind.SERIA_NIEZGODNA": "Numer wFirma nie pasuje do szablonu zmapowanej serii",
  "invoices.engine.no_wfirma_invoice": "Numer SellBase nadany — faktury w wFirma jeszcze nie ma",
  "invoices.wfirma.status.DISPATCHING": "Wynik wysyłki nieustalony",
  "invoices.wfirma.status.KSEF_REJECTED": "KSeF odrzucił",
  "invoices.wfirma.date_shift_title": "Zmiana daty wystawienia",
  "invoices.wfirma.date_shift_body": "Data wystawienia zmieni się z {old} na {new} (dziś). W wFirma i KSeF faktura dostanie dzisiejszą datę; numer SellBase się nie zmienia (przy zmianie miesiąca dostanie nowy numer w nowym miesiącu).",
  "invoices.wfirma.date_shift_ok": "Wyślij z dzisiejszą datą",
  "invoices.wfirma.reconcile_title": "Wynik wysyłki nieustalony",
  "invoices.wfirma.reconcile_desc": "Nie wiemy, czy wFirma utworzyła fakturę. Sprawdź w panelu wFirma i wybierz, co się stało.",
  "invoices.wfirma.reconcile_error_desc": "wFirma odrzuciła dokument — faktury tam nie ma. Popraw dane i wyślij ponownie albo uzgodnij.",
  "invoices.wfirma.reconcile_absent": "Nie ma w wFirma — wyślij ponownie",
  "invoices.wfirma.reconcile_present": "Jest w wFirma — podaj ID",
  "invoices.wfirma.reconcile_cancel": "Nie ma w wFirma — do anulowania",
  "invoices.wfirma.reconcile_confirm_absent": "Potwierdzasz, że sprawdziłeś w panelu wFirma i faktury tam nie ma? Dokument wróci do kolejki i zostanie wysłany z dzisiejszą datą.",
  "invoices.wfirma.reconcile_confirm_cancel": "Potwierdzasz, że faktury nie ma w wFirma? Dokument zostanie oznaczony jako niedoręczony i będzie można go anulować.",
  "invoices.wfirma.reconcile_prompt_id": "Podaj identyfikator faktury w wFirma (liczba z adresu w panelu wFirma)",
  "invoices.wfirma.reconciled": "Uzgodniono wynik wysyłki",
  "invoices.wfirma.auto_send_desc": "Gdy wyłączone, wystawiony dokument czeka na przycisk „Wyślij do wFirma” (lista „Wymaga uwagi”). Wysyłka faktury B2B do wFirma oznacza wysyłkę do KSeF, której nie da się cofnąć.",
  "invoices.wfirma.series_type_mismatch": "Seria wFirma ma inny typ niż seria SellBase (np. proforma ↔ faktura). Popraw mapowanie.",
  "invoices.wfirma.series_type_hint": "Dozwolone typy wFirma: {types}",
  "invoices.issue.date_today_note": "Datą wystawienia będzie dzień wystawienia (dziś), numer z tego dnia; dokument od razu trafi do wFirma.",
  "invoices.issue.retry_drafts_body": "Wystawione szkice dostaną dzisiejszą datę i numer i zostaną wysłane do wFirma (faktury B2B trafią do KSeF). Dotyczy też szkiców starszych niż 3 dni — automat ich nie wystawia, to Twoja decyzja.",
  "invoices.history.issue_date_changed": "Zmieniono datę wystawienia",
  "invoices.history.number_changed": "Zmieniono numer (nowy okres numeracji)",
  "invoices.history.outbound_started": "Rozpoczęto wysyłkę",
  "invoices.history.outbound_rejected": "wFirma odrzuciła dokument (faktura nie powstała)",
  "invoices.history.dispatch_reconciled": "Uzgodniono wynik wysyłki",
  "invoices.series.proforma.toggle": "Seria proform (dokument nie jest fakturą)",
  "invoices.series.proforma.desc": "Proforma nie jest fakturą VAT: nie idzie do wFirma ani KSeF, nie ma korekt, nie liczy się do zestawień VAT/EPP. Z zamówienia z proformą nadal wystawisz zwykłą fakturę.",
  "invoices.series.proforma.label": "Proforma",
  "invoices.proforma.note": "Proforma — nie jest fakturą, nie jest wysyłana do wFirma ani KSeF",
  "invoices.allegro.not_ready": "Na Allegro trafia wyłącznie faktura z wFirma po zakończeniu KSeF",
  "invoices.wfirma.reconcile_search_hint": "Próba wysyłki: {time}. Wyszukaj w panelu wFirma fakturę na kwotę {amount} {currency} dla nabywcy {buyer}.",
  "invoices.wfirma.reconcile_too_early": "Za wcześnie na uzgodnienie — wFirma mogła jeszcze nie skończyć przetwarzania. Możliwe od {time}.",
  "invoices.wfirma.reconcile_mismatch_title": "Faktura wFirma nie zgadza się z dokumentem",
  "invoices.wfirma.reconcile_mismatch_body": "wFirma: {number} · {total} {currency} · {buyer}. Różnice:",
  "invoices.wfirma.reconcile_mismatch_ok": "To ta faktura — zapisz",
  "invoices.engine.kind.KURS_PO_ZMIANIE_DATY": "Dokument walutowy dostał nową datę wystawienia — kurs i kwoty PLN w SellBase są z dawnej daty",
  "invoices.engine.kind.ZWROT_BEZ_KOREKTY": "Automat nie wystawił korekty do zwrotu (powód w historii zamówienia) — wystaw korektę ręcznie",
  "invoices.engine.info_only": "Informacje (wFirma/KSeF)",
  "invoices.engine.acknowledge": "Przyjąłem",
  "invoices.engine.acknowledge_hint": "Sprawa informacyjna — zniknie z listy, zapiszemy kto i kiedy",
  "invoices.engine.acknowledged": "Przyjęto do wiadomości",
  "invoices.engine.ack_failed": "Nie udało się zapisać",
  "invoices.engine.kind.KOREKTA_OZNACZONA_BEZ_KSEF": "Korekta faktury z numerem KSeF poszła jako „Bez KSeF” — musi trafić do KSeF (art. 106j ust. 4)",
  "invoices.engine.kind.WFIRMA_BEZ_ROZSTRZYGNIECIA": "Dokument w wFirma ponad 24 h bez rozstrzygnięcia KSeF (ani numer, ani „Bez KSeF”) — sprawdź w panelu wFirma",
  "invoices.engine.kind.SZKIC_DO_WYSLANEGO": "Zamówienie ma nadaną przesyłkę, a faktura jest tylko szkicem — popraw dane i wystaw",
  "invoices.engine.kind.FAKTURA_DO_ANULOWANEGO": "Zamówienie anulowane, a faktura nie ma korekty do zera — wystaw korektę albo potwierdź realizację",
  "invoices.engine.kind.PROFORMA_W_KSEF": "Proforma ma numer KSeF — w KSeF jest fakturą VAT; księgowa decyduje: zostaje jako sprzedaż albo korekta",
  "invoices.engine.kind.ANULOWANY_W_WFIRMA": "Dokument anulowany w SellBase ma fakturę w wFirma — sprawdź, czy anulowano ją też w wFirma",
  "dashboard.kpi.definition": "Definicja wskaźnika",
  "dashboard.kpi.incomplete": "Dane niepełne",
  "dashboard.kpi.incomplete_sources": "Nie wczytano danych z: {sources}",
  "dashboard.kpi.fx_unconverted": "kwoty w walucie {currency} nieprzeliczone ({amount} {currency}) — brak kursu NBP",
  "dashboard.kpi.fx_fallback": "część kwot po kursie zastępczym (NBP nieosiągalne)",
  "dashboard.kpi.fx_gaps": "brak kursów NBP dla części dni",
  "dashboard.hint.revenue_today": "Suma zamówień z DNIA ZAKUPU w dobie polskiej (Europe/Warsaw), ze wszystkich kanałów łącznie z zamówieniami ręcznymi i WooCommerce. Bez anulowanych i zwróconych według stanu bieżącego (anulowanie dziś zmienia też dni minione). Łącznie z nieopłaconymi. Zwroty częściowe nieodejmowane (Statystyki je odejmują, więc mogą pokazać mniej). Waluty po średnim kursie NBP z dnia zakupu; do południa dzisiejsze kwoty idą po wczorajszej tabeli. To wskaźnik sprzedażowy — wiążące kwoty faktur są w wFirma.",
  "dashboard.hint.revenue_today_paid": "Suma zamówień z DNIA ZAPŁATY (data zapłaty, a gdy jej brak — data zakupu) w dobie polskiej. PrestaShop, Erli i eBay nie podają daty zapłaty — liczone po dniu zakupu. Poza tym jak dla dnia zakupu: wszystkie kanały, bez anulowanych i zwróconych według stanu bieżącego, łącznie z nieopłaconymi, zwroty częściowe nieodejmowane, kurs NBP z dnia. Wskaźnik sprzedażowy — wiążące kwoty faktur są w wFirma.",
  "dashboard.hint.orders_today": "Liczba zamówień z dnia zakupu w dobie polskiej, ze wszystkich kanałów łącznie z ręcznymi. Bez anulowanych i zwróconych według stanu bieżącego, łącznie z nieopłaconymi.",
  "dashboard.hint.orders_today_paid": "Liczba zamówień z dnia zapłaty (gdy brak daty zapłaty — z dnia zakupu; PrestaShop, Erli i eBay zawsze po dniu zakupu). Bez anulowanych i zwróconych według stanu bieżącego.",
  "dashboard.hint.new_customers": "Klienci, których PIERWSZE nieanulowane i niezwrócone zamówienie w całej historii (wszystkie kanały łącznie) wypada danego dnia zakupu. Anulowane zamówienia nie liczą się wcale. Ta sama definicja dla kafelka, porównania i wykresu; zawsze po dniu zakupu.",
  "dashboard.hint.avg_value": "Przychód dnia (PLN po kursie NBP z dnia) podzielony przez liczbę zamówień — ta sama definicja co „Przychód dziś” i „Zamówienia dziś”.",
  "dashboard.hint.month_total": "Przychód i liczba zamówień od 1. dnia bieżącego miesiąca do dziś, po dniu zakupu, wszystkie kanały, bez anulowanych i zwróconych według stanu bieżącego, łącznie z nieopłaconymi, waluty po kursie NBP z dnia zakupu. Zwroty częściowe nieodejmowane.",
  "dashboard.hint.month_total_paid": "Przychód i liczba zamówień od 1. dnia miesiąca do dziś po dniu zapłaty (gdy brak — po dniu zakupu; PrestaShop, Erli i eBay po dniu zakupu). Bez anulowanych i zwróconych, łącznie z nieopłaconymi, kurs NBP z dnia.",
  "dashboard.hint.sales_per_marketplace": "Udział każdego kanału i konta, również zamówień ręcznych, w dzisiejszym przychodzie (PLN po kursie NBP z dnia). Ta sama suma co „Przychód dziś”.",
  "dashboard.hint.top_products": "Najczęściej sprzedawane pozycje z ostatnich 7 dni — TYLKO zamówienia z tabeli Allegro (Allegro, ręczne, WooCommerce); PrestaShop, Erli, eBay, TikTok i Von Halsky nie są tu ujęte. Sztuki z pozycji zamówień, przychód PLN po kursie NBP z dnia zakupu, bez anulowanych.",
  "dashboard.hint.attention_needed": "Wiadomości czekające na RĘCZNĄ odpowiedź (auto-odpowiedzi się nie liczą) oraz sprawy posprzedażowe bez reakcji — z ostatnich 30 dni.",
  "dashboard.hint.sales_chart": "Zamówienia i przychód po dniu zakupu w dobie polskiej, wszystkie kanały, bez anulowanych i zwróconych według stanu bieżącego, kurs NBP z dnia. Ten sam przelicznik co kafelki — ta sama kwota dnia co do grosza.",
  "dashboard.basis.label": "Dzień liczony według:",
  "dashboard.basis.short": "Dzień:",
  "dashboard.basis.bought": "zakupu",
  "dashboard.basis.paid": "zapłaty",
  "dashboard.basis.hint": "Dzień zapłaty = data zapłaty, a gdy jej brak — data zakupu. PrestaShop, Erli i eBay nie podają daty zapłaty, więc liczone są po dniu zakupu. „Nowi klienci” zawsze po dniu zakupu.",
  "dashboard.compare.yesterday_same_time": "wczoraj do {time}",
  "stats.incomplete": "Dane niepełne",
  "stats.incomplete_sources": "Nie wczytano danych z: {sources}",
  "stats.fx_unconverted": "kwoty w walucie {currency} nieprzeliczone ({amount} {currency}) — brak kursu NBP",
  "stats.fx_fallback": "część kwot po kursie zastępczym (NBP nieosiągalne)",
  "dashboard.kpi.fx_stale": "część kwot po kursie NBP starszym niż 4 dni (luka w kursach)",
  "stats.fx_stale": "część kwot po kursie NBP starszym niż 4 dni (luka w kursach)",
  "dashboard.hint.sales_chart_paid": "Zamówienia i przychód po dniu ZAPŁATY (data zapłaty, a gdy jej brak — data zakupu; PrestaShop, Erli i eBay po dniu zakupu) w dobie polskiej, wszystkie kanały, bez anulowanych i zwróconych według stanu bieżącego, kurs NBP z dnia. Ten sam przelicznik co kafelki.",
  "dashboard.basis.error": "Nie udało się przełączyć podstawy dnia — pokazujemy poprzednie liczby.",
  "invoices.tax_block.title": "Dlaczego to szkic",
  "invoices.tax_block.VAT0_KRAJ": "Stawka 0% w fakturze krajowej bez podstawy. Firma nie prowadzi sprzedaży krajowej 0%, zwolnionej ani eksportu — przelicz stawki albo wystaw dokument ręcznie w wFirma.",
  "invoices.tax_block.VAT_STAWKA_PL": "Stawka pozycji nie obowiązuje w Polsce w dniu sprzedaży.",
  "invoices.tax_block.VAT_BRAK_STAWKI": "Brak zatwierdzonej stawki VAT dla tego kraju na dzień sprzedaży. Uzupełnij ją w Ustawieniach faktur → Stawki VAT UE.",
  "invoices.tax_block.WSTO_SERIA_KRAJOWA": "Konsument z dostawą do innego kraju UE w serii krajowej — sprzedaż wysyłkowa rozlicza się stawką kraju dostawy (OSS).",
  "invoices.tax_block.OSS_KRAJ_ROZNY": "Adres do faktury wskazuje inny kraj niż dostawa. Wybierz kraj rozliczenia OSS i wystaw dokument ręcznie.",
  "invoices.tax_block.OSS_KRAJ_POZA_UE": "Kraj konsumpcji jest spoza UE — procedura OSS go nie obejmuje. Eksport wystawia się ręcznie w wFirma.",
  "invoices.tax_block.OSS_KRAJ_PL": "Kraj konsumpcji to Polska — to sprzedaż krajowa, nie OSS. Wystaw dokument z serii krajowej.",
  "invoices.tax_block.OSS_STAWKA": "Stawka pozycji nie obowiązuje w kraju konsumpcji w dniu sprzedaży.",
  "invoices.tax_block.WDT_NABYWCA_PL": "Dostawa wewnątrzwspólnotowa nie dotyczy nabywcy z Polski ani dostawy do Polski.",
  "invoices.tax_block.WDT_BRAK_NUMERU": "Dostawa wewnątrzwspólnotowa (0%) wymaga numeru VAT-UE nabywcy.",
  "invoices.tax_block.WDT_FORMAT": "Numer VAT-UE nie pasuje do formatu kraju nabywcy — nie może być ważny.",
  "invoices.tax_block.WDT_VIES_NIEAKTYWNY": "VIES zwrócił numer nabywcy jako nieaktywny — stawka 0% (WDT) nie przysługuje.",
  "invoices.tax_block.WDT_VIES_NIEDOSTEPNY": "VIES nie potwierdził numeru (usługa niedostępna). Dokument czeka jako szkic, ponowienie nastąpi automatycznie.",
  "invoices.tax_block.WDT_VIES_INNY_NUMER": "Zapisany dowód VIES dotyczy innego numeru niż ten na dokumencie.",
  "invoices.tax_block.WDT_STAWKA": "Dostawa wewnątrzwspólnotowa ma stawkę 0%, a pozycja ma inną.",
  "invoices.tax_block.KWOTY_POZYCJI": "Kwoty pozycji nie spinają się ze stawką (netto + VAT ≠ brutto).",
  "invoices.tax_block.KOREKTA_STAWKA_INNA": "Korekta zmienia stawkę względem faktury pierwotnej — korektę stawki wystaw w wFirma.",
  "invoices.tax_block.recalc": "Przelicz stawki według serii",
  "invoices.tax_block.recalc_hint": "Brutto pozycji zostaje bez zmian — zmienia się tylko rozbicie na netto i VAT.",
  "invoices.tax_block.recalc_done": "Przeliczono stawki ({n} poz.) — brutto bez zmian",
  "invoices.tax_block.vies_now": "Sprawdź VIES teraz",
  "invoices.tax_block.to_oss": "Zmień na OSS",
  "invoices.tax_block.vies_ok": "VIES potwierdził numer {nr} (konsultacja {id})",
  "invoices.tax_block.vies_bad": "VIES nie potwierdził numeru {nr}",
  "invoices.list.tax_drafts": "Szkice do decyzji podatkowej",
  "invoices.vies.no_proof": "Brak dowodu VIES z dnia wystawienia",
  "invoices.vies.no_proof_hint": "Ten dokument WDT wyszedł ze stawką 0% bez zapisanego potwierdzenia VIES.",
  "invoices.vies.live_hint": "stan na dziś — nie jest dowodem na dzień dostawy",
  "vat.rates.title": "Stawki VAT UE",
  "vat.rates.subtitle": "Stawki obowiązujące danego dnia. To one, a nie zewnętrzne źródło, decydują o stawce na fakturze.",
  "vat.rates.on_day": "Na dzień",
  "vat.rates.country": "Kraj",
  "vat.rates.standard": "Podstawowa",
  "vat.rates.reduced": "Obniżone",
  "vat.rates.history": "Historia okresów",
  "vat.rates.valid_from": "Obowiązuje od",
  "vat.rates.valid_to": "Do",
  "vat.rates.proposals": "Zgłoszone zmiany stawek",
  "vat.rates.proposals_empty": "Brak zgłoszonych zmian — źródło stawek nie sygnalizuje różnic.",
  "vat.rates.proposal_row": "{kraj}: {z} % → {na} %",
  "vat.rates.suspicious": "podejrzana",
  "vat.rates.approve": "Zatwierdź",
  "vat.rates.reject": "Odrzuć",
  "vat.rates.approve_from": "Od którego dnia obowiązuje nowa stawka?",
  "vat.rates.approved": "Zatwierdzono stawkę {kraj} {stawka} % od {od}",
  "vat.rates.rejected": "Propozycja odrzucona",
  "vat.rates.master_only": "Zmiany stawek zatwierdza konto master.",
  "invoices.sale_date_basis.payment": "data zapłaty (przedpłata)",
  "invoices.sale_date_basis.dispatch": "data wydania towaru (nadanie paczki)",
  "invoices.sale_date_basis.placement": "data złożenia zamówienia",
  "invoices.sale_date_basis.issue": "data wystawienia",
  "invoices.sale_date_basis.manual": "wpisana ręcznie",
  "invoices.sale_date_basis.delivery": "data doręczenia przesyłki (pobranie)",
  "invoices.validation.item_name_generic": "Nazwa pozycji musi określać towar lub usługę (art. 106e ust. 1 pkt 7) — „produkt 1” czy „Pozycja” nie wystarczą.",
  "invoices.mpp.title": "Mechanizm podzielonej płatności (MPP)",
  "invoices.mpp.hint": "Faktura powyżej 15 000 zł brutto dla firmy z NIP. Zaznacz, czy dotyczy jej mechanizm podzielonej płatności (załącznik 15 do ustawy o VAT) — SellBase tego nie zgaduje.",
  "invoices.mpp.choice_none": "— wybierz —",
  "invoices.mpp.choice_yes": "Tak — obowiązuje MPP",
  "invoices.mpp.choice_no": "Nie dotyczy",
  "invoices.series.sale_date_info_title": "Data sprzedaży",
  "invoices.series.sale_date_info": "liczona z zamówienia — data zapłaty przy przedpłacie, data wydania towaru przy pobraniu i płatności po wysyłce (czas polski).",
  "invoices.series.mpp_info_title": "Podzielona płatność (MPP)",
  "invoices.series.mpp_info": "ustalana na dokumencie — faktura powyżej 15 000 zł brutto dla firmy z NIP czeka na decyzję „MPP tak / nie dotyczy”.",
  "invoices.series.current_number_readonly": "Licznik techniczny — przy resecie okresowym nie jest następnym numerem",
  "invoices.series.twin_badge": "bliźniacza",
  "disputes.po_terminie.definicja": "Po terminie: sprawy wymagające reakcji — termin odpowiedzi/decyzji minął, sprzedający jeszcze nie odpowiedział, a sprawa nie jest zamknięta (zamknięte: zakończona, odrzucona, przyjęta, rozwiązana, zwrócono pieniądze, anulowana). Liczone na żywo dla całej zakładki i wybranego konta, nie tylko bieżącej strony.",
  "disputes.po_terminie.na_stronie": "Na bieżącej stronie listy: {n}.",
  "disputes.po_terminie.niedostepne": "Nie udało się pobrać licznika całej zakładki — pokazujemy sprawy po terminie z bieżącej strony listy ({n}).",
  "invoices.series.active_via_twin": "Tak (przez #{id})",
  "invoices.series.twin_hint": "Inna seria tej firmy ma tę samą numerację (nazwa, prefiks, suffix)",
  "invoices.series.twin_automation": "Automat wystawia z serii bliźniaczej — zmiany numeracji tutaj nie działają na automat",
  "invoices.series.twin_banner": "Tę samą numerację ma też seria bliźniacza",
  "invoices.series.twin_automation_banner": "Automat wystawia z serii bliźniaczej",
  "invoices.series.twin_automation_hint": "zmiany numeracji tutaj nie działają na automat.",
  "invoices.series.numbering_change_title": "Zmiana numeracji serii",
  "invoices.series.numbering_change_msg": "Seria ma już ponumerowane dokumenty. Zmiana dotyczy dokumentów wystawianych od teraz — istniejące numery zostają bez zmian.",
  "invoices.series.numbering_change_ok": "Zmień numerację",
  "invoices.correction.binding_number_wfirma": "Numer nada wFirma. Numer SellBase poniżej jest wewnętrzny.",
  "mpo.fam_kind_product": "Produkt SellBase",
  "mpo.fam_kind_set": "Zestaw SellBase",
  "mpo.fam_offer_id_hint": "Numer oferty na marketplace",
  "mpo.fam_last_sold": "ost. {d}",
  "mpo.fam_sort_hint": "Kliknij, aby sortować",
  "products.model_join": "Dołącz do modelu…",
  "products.model_joined_info": "dołączony ręcznie — model i pień",
  "products.porzadek_e4_join": "Dołącz do modelu…",
  "products.porzadek_e4_joined": "Dołączono do modelu",
  "products.porzadek_e4_join_title": "Jeden zapis: miejsce w Katalogu i pień dla Ofert oraz Porządku — podpowiedź z początku SKU",
  "products.scal_moved_identyfikatory_dopisane": "EAN/SKU scalanych kart dopisanych jako dodatkowe",
  "products.porzadek_s14_all": "Zaznacz wszystkie na stronie",
  "products.porzadek_s14_bulk": "Ustaw ×N dla zaznaczonych",
  "products.porzadek_s14_bulk_hint": "Najpierw podgląd: każdą liczbę możesz poprawić, pozycje z ostrzeżeniem są odznaczone.",
  "products.porzadek_s14_chk": "Zaznacz do ustawienia ×N hurtem",
  "products.porzadek_s09_offer": "Oferta marketplace",
  "products.porzadek_s09_open_mp": "otwórz na marketplace",
  "products.porzadek_s09_offer_pcs": "oferta: {n} szt.",
  "products.porzadek_s09_drawer": "Otwórz szufladę oferty",
  "products.porzadek_s09_suggested": "Propozycja SellBase",
  "products.porzadek_s09_current": "Dziś powiązana",
  "products.porzadek_s09_name_pcs": "w nazwie: {n} szt.",
  "products.porzadek_s14_src_allegro": "podpowiedź z Allegro (wielopak)",
  "products.porzadek_s14_src_title": "podpowiedź z tytułu oferty",
  "products.porzadek_s66_now": "teraz ×{n} — jeśli dobrze, kliknij „To celowe”",
  "products.porzadek_s66_saved_intended": "zapisano ×{q} jako świadomą krotność (tytuł mówi {n}×)",
  "products.porzadek_s09_save": "Zapisz",
  "products.porzadek_s14_sales": "Sprzedaż 30 dni: {s} szt. oferty — zdjęto {z} szt. karty{po}",
  "products.porzadek_s14_sales_po": ", przy ×{p} byłoby {n}",
  "products.porzadek_s14_unit": "Cena za sztukę: {c} zł (oferta {o} / {n} szt.)",
  "products.porzadek_s14_single": " · pojedyncza oferta tej karty: {c} zł",
  "products.porzadek_s14_other": "Inne oferty tej karty: {l}",
  "products.porzadek_s14_other_none": "Inne oferty tej karty: brak",
  "products.porzadek_s14_allegro_pack": "Allegro: wielopak ×{n}",
  "products.porzadek_s14_allegro_single": "Allegro: zwykła oferta (×1)",
  "products.porzadek_s14_stock": "Stan karty {s} szt. = {n} sprzedaży przy ×{p}",
  "products.porzadek_s14_details": "Szczegóły",
  "products.porzadek_s09_product": "Produkt SellBase",
  "products.porzadek_s09_pick": "Wybierz kartę produktu",
  "products.porzadek_s09_effect": "jedna sprzedaż zdejmie: {q} × {sku}{szt}",
  "products.porzadek_s09_effect_diff": "— oferta mówi {n} szt.",
  "products.porzadek_s09_confirm_relink": "Przepiąć ofertę na inną kartę?",
  "products.porzadek_s09_confirm_qty": "Zmienić krotność powiązania?",
  "products.porzadek_s09_confirm_msg": "Oferta {mp} {id}: jedna sprzedaż zdejmie {po}.",
  "products.porzadek_s09_today": "Dziś: {k}",
  "products.porzadek_s09_after": "Po zmianie: {k}",
  "products.porzadek_s09_warn": "Uwaga: {t}",
  "products.porzadek_s09_note_relink": "Stan zdjęty przez wcześniejsze sprzedaże zostaje na dotychczasowej karcie; nowe sprzedaże zdejmą stan z nowej karty.",
  "products.porzadek_s09_note_qty": "Zmiana samej krotności działa od następnej sprzedaży; stan zostaje bez zmian.",
  "products.porzadek_s14_bulk_n": "Ustaw ×N dla zaznaczonych ({n})",
  "products.porzadek_s14_col_offer": "Oferta",
  "products.porzadek_s14_col_card": "Karta",
  "products.porzadek_s14_col_today": "Dziś",
  "products.porzadek_s14_row": "Zapisz ten wiersz",
  "products.porzadek_s14_modal_note": "Zapis tą samą drogą co pojedyncza zmiana: od następnej sprzedaży, stan magazynu bez zmian, zero zapisów do marketplace.",
  "products.porzadek_s14_modal_title": "Ustaw krotność dla {n} ofert",
  "products.porzadek_cancel": "Anuluj",
  "products.porzadek_s14_modal_save": "Zapisz zaznaczone",
  "products.porzadek_s14_none": "Nic nie zaznaczono",
  "products.porzadek_s14_progress": "Zapisuję {i}/{n}…",
  "products.porzadek_s14_done_err": "Zapisano {ok}, błędy: {n} ({p})",
  "products.porzadek_s14_done": "Zapisano krotność dla {ok} ofert",
  "products.porzadek_s14_unchanged": "Bez zmian: {n} — krotność taka sama jak dziś, odznacz albo popraw",
  "products.porzadek_s15_all": "Wszystkie",
  "products.porzadek_s15_fix": "Popraw na marketplace",
  "products.porzadek_s15_check": "Sprawdź",
  "products.porzadek_s15_hint_fix": "Popraw w ofercie",
  "products.porzadek_s15_hint_check": "Do sprawdzenia",
  "products.porzadek_s15_ean_pair": "EAN na marketplace {a} · EAN karty {b}",
  "products.porzadek_s15_owner": "EAN {e} ma karta #{id} {sku}",
  "products.porzadek_s15_from_product": "EAN pochodzi z produktu przypisanego do oferty w katalogu Allegro",
  "products.porzadek_s15_refresh_err": "Nie udało się odświeżyć: {e}",
  "products.porzadek_s15_refreshed": "Dane oferty odświeżone — jeśli poprawka weszła, pozycja zniknie z listy",
  "products.porzadek_s15_open_owner": "karta #{id} {sku}",
  "channels.ean_foreign_title": "EAN paczki należy w GS1 do innego produktu",
  "channels.ean_related_title": "EAN wariantu albo zestawu — sprawdź produkt",
  "channels.use_product_ean": "Użyj EAN produktu",
  "offer_drafts.ean_fixed": "Paczka dostała EAN produktu {ean} — wystawiam ponownie",
  "offer_drafts.ean_fixed_short": "Paczka dostała EAN produktu {ean}",
  "offer_drafts.ean_already": "Paczka ma już EAN produktu {ean}",
  "offer_drafts.draft_hint": "Oferta trafi na Allegro jako szkic (nieaktywna) — dokończysz i wystawisz ją na Allegro albo w Ofertach marketplace",
  "offer_drafts.cta_send_draft": "albo wyślij jako szkic",
  "offer_drafts.menu_send_draft": "Wyślij do Allegro jako szkic",
  "offer_drafts.send_draft": "Wyślij jako szkic",
  "offer_drafts.send_draft_full": "Wyślij szkic na Allegro",
  "offer_drafts.send_draft_1": "Wyślij szkic na 1 konto",
  "offer_drafts.send_draft_234": "Wyślij szkic na {n} konta",
  "offer_drafts.send_draft_5plus": "Wyślij szkic na {n} kont",
  "offer_drafts.pick_accounts_draft": "Wyślij do Allegro jako szkic — wybierz konta",
  "offer_drafts.confirm_publish_draft_title": "Wysłać szkic oferty?",
  "offer_drafts.confirm_publish_draft": "Wyślesz ofertę jako szkic (nieaktywna, kupujący jej nie zobaczą) na: {accounts}. Kontynuować?",
  "offer_drafts.confirm_publish_draft_ok": "Wyślij szkic",
  "offer_drafts.sending_draft": "Wysyłanie szkicu...",
  "offer_drafts.sending_draft_title": "Wysyłanie szkicu na Allegro",
  "offer_drafts.pub_done_draft": "Szkic na Allegro (nieaktywna)",
  "offer_drafts.sent_draft_toast": "Szkic oferty wysłany na Allegro",
  "offer_drafts.draft_word": "szkic",
  "offer_drafts.hist_kind_publish_ok_draft": "Wysłano szkic",
  "offer_drafts.all_published": "Wystawiona na wszystkich kontach",
  "offer_drafts.conn_error": "Błąd połączenia",
  "offer_drafts.delete": "Usuń całkowicie",
  "offer_drafts.deleted_toast": "Oferta usunięta",
  "offer_drafts.done": "Gotowe",
  "offer_drafts.edit_dane": "Cena, ilość i dane",
  "offer_drafts.edit_dane_hint": "Cena, ilość, SKU, EAN, dane źródłowe z add",
  "offer_drafts.menu_edit_dane": "Cena, ilość, SKU i EAN",
  "offer_drafts.menu_edit_tresc": "Edytuj ofertę (tytuł, zdjęcia, opis, parametry)",
  "offer_drafts.open_card": "Otwórz kartę",
  "offer_drafts.pick_accounts": "Wystaw na Allegro — wybierz konta",
  "offer_drafts.pub_already": "Już wystawiona wcześniej",
  "offer_drafts.pub_already_short": "Wystawiona",
  "offer_drafts.pub_done": "Wystawiona",
  "offer_drafts.pub_failed": "Publikacja nieudana",
  "offer_drafts.pub_remap": "Dopasowano do konta:",
  "offer_drafts.pub_wait": "W kolejce",
  "offer_drafts.publish_1": "Wystaw na 1 konto",
  "offer_drafts.publish_234": "Wystaw na {n} konta",
  "offer_drafts.publish_5plus": "Wystaw na {n} kont",
  "offer_drafts.publish_more": "Wystaw na kolejne konta",
  "offer_drafts.publishing_title": "Wystawianie na Allegro",
  "offer_drafts.retry_failed": "Ponów nieudane",
  "offer_drafts.saved_toast": "Zmiany zapisane",
  "offer_drafts.select_all": "Zaznacz wszystkie",
  "offer_drafts.unselect_all": "Odznacz wszystkie",
  "offer_drafts.hist_kind_inbound_oczekuje": "Nowa paczka z aukcjonera czeka (szkic edytowany w SellBase)",
  "offer_drafts.hist_kind_inbound_odrzucona": "Zostawiono wersję z SellBase (paczka odrzucona)",
  "offer_drafts.hist_kind_z_produktu": "Utworzono szkic z karty produktu",
  "products.porzadek_kind_bliznieta": "Bliźniak z innym SKU",
  "products.porzadek_opis_bliznieta": "Ta sama oferta (identyczny tytuł albo pierwsze zdjęcie) na kilku kontach jednego kanału, a na każdym koncie podpięta pod inną kartę. Na złej karcie sprzedaż zdejmuje stan nie tego towaru. Otwórz szufladę oferty, porównaj kody i przepnij; tytuł to tylko trop.",
  "products.porzadek_kind_duplikaty_ofert": "Duplikaty ofert",
  "products.porzadek_opis_duplikaty_ofert": "Kilka aktywnych ofert tego samego towaru na jednym koncie (ta sama karta, ten sam tytuł). Podpowiedź: zostaw ofertę z największą sprzedażą w 365 dni. Pozostałe kończysz ręcznie na marketplace, bo SellBase ofert nie kończy.",
  "products.porzadek_kind_ten_sam_towar": "Ten sam towar na dwóch kartach",
  "products.porzadek_opis_ten_sam_towar": "Dwie karty z danymi jednego towaru: EAN jednej jest w GS1 zapisany pod SKU drugiej albo oferty obu kart niosą ten sam SKU i EAN. Proponowana karta, która zostaje, to ta, której SKU jest symbolem EAN w GS1. Scalasz po podglądzie wpływu albo oznaczasz starszą wersję. Stany nie są sumowane.",
  "products.porzadek_kind_tytul_vs_karta": "Tytuł / producent ≠ karta",
  "products.porzadek_opis_tytul_vs_karta": "Marka albo kolor w tytule oferty różni się od karty. Mocniejszy sygnał: marka w „Kodzie producenta” produktu z katalogu Allegro inna niż karta. Tylko do obejrzenia: porównaj zdjęcia. Jeśli to inny towar, przepnij ofertę w szufladzie albo popraw ją u źródła.",
  "products.porzadek_s49_sales365": "sprzedaż 365 d: {n} szt.",
  "products.porzadek_s49_keep": "zostaw tę",
  "products.porzadek_s49_card": "karta #{id} {sku}",
  "products.porzadek_s49_drawer": "Szuflada",
  "products.porzadek_s58_bulk": "Złóż zestawy hurtem…",
  "products.porzadek_s58_bulk_hint": "Lista z tej strony: zaznaczone są tylko krotności z sufiksu SKU; liczby z nazwy sprawdź przed zaznaczeniem. Zapis po podglądzie zestawów.",
  "products.porzadek_s58_no_suffix": "skład nieznany — SKU bez końcówki zestawu",
  "products.porzadek_s58_import": "zestaw w imporcie: {src}",
  "products.porzadek_s58_stock": "stan z importu: {n}",
  "products.porzadek_s58_links": "oferty podpięte ×{n}",
  "products.porzadek_s58_title": "Złożyć zestawy?",
  "products.porzadek_s58_msg": "Każda karta stanie się zestawem N × baza. Stan karty z importu przestaje się liczyć — zestaw bierze stan ze składników. Odznacz pozycje, których krotności nie jesteś pewien.",
  "products.porzadek_s58_check": "krotność z nazwy, sprawdź",
  "products.porzadek_s58_ok": "Złóż {n}",
  "products.porzadek_s58_done": "Złożono zestawy: {n}",
  "products.scal_ean_title": "EAN po scaleniu",
  "products.scal_ean_sub": "Wybierz EAN główny przeżywającej. Pozostałe numery zostają jako dodatkowe — odznacz numer, który w GS1 należy do innego towaru.",
  "products.scal_ean_no_gs1": "spoza GS1",
  "products.scal_ean_foreign": "GS1: cudzy — SKU {sku}",
  "products.scal_ean_owner": "GS1: SKU {sku}",
  "products.scal_ean_keep": "zostaw jako dodatkowy",
  "products.scal_stock_from_sum": "{n} — z karty #{id}",
  "products.scal_stock_keep_sum": "{n} — stan przeżywającej #{id} bez zmiany",
  "products.scal_stock_manual_sum": "{n} — wpisany ręcznie",
  "products.scal_stock_manual_bad": "Wpisz stan po scaleniu (liczba całkowita ≥ 0) albo wybierz kartę, z której go wziąć",
  "products.scal_stock_manual_aria": "Stan po scaleniu wpisany ręcznie",
  "products.scal_stock_manual": "Wpisz ręcznie",
  "products.scal_stock_bundle_short": "stan zestawu ze składników",
  "products.scal_stock_bundle": "Przeżywająca karta jest zestawem — jej stan wynika ze składników.",
  "products.scal_stock_sub": "Wybierz kartę, z której przeżywająca weźmie stan, albo wpisz stan ręcznie. Zmiana trafi do historii ruchów magazynu.",
  "products.scal_stock_title": "Stan po scaleniu",
  "products.porzadek_s58_name_qty": "nazwa karty: {n} szt. — inna liczba niż w SKU",
  "mpo.fam_pw_zestaw_ok": "zgodne ze składem Allegro",
  "offer_drafts.paczka_chip": "nowa wersja z add",
  "offer_drafts.paczka_chip_title": "add przysłał nową wersję tej oferty — otwórz szkic i wybierz: wczytaj albo zostaw swoją",
  "products.scal_ean_foreign_main": "Numer innego towaru według GS1 — nie może być głównym EAN-em",
  "channels.merge_with": "Scal z",
  "channels.alias_code": "dodatkowy",
  "products.scal_ean_auto": "Przeżywająca karta nie ma EAN-u — EAN {ean}{skad} zostanie jej głównym EAN-em.",
  "products.scal_ean_main_sum": "EAN główny",
  "products.scal_photos_title": "Zdjęcia po scaleniu",
  "products.scal_photos_sub": "Przeżywająca karta nie ma zdjęć — wybierz, czyja galeria do niej przejdzie.",
  "products.scal_photos_count": "{n} zdj.",
  "products.scal_photos_none": "Bez zdjęć (dodam później)",
  "products.scal_photos_sum": "galeria karty #{id} ({n} zdj.)",
  "products.scal_moved_zdjecia": "zdjęć do pustej galerii przeżywającej",
  "products.scal_ean_none": "Bez głównego EAN — wszystkie numery jako dodatkowe",
  "products.porzadek_s134_open": "Karta",
  "products.porzadek_s134_open_title": "Otwórz kartę produktu #{id} nad kolejką",
  "offer_drafts.bulk_acc_has": "{n} z zaznaczonych już tu jest — pominę",
  "offer_drafts.bulk_all": "Zaznacz wszystkie widoczne",
  "offer_drafts.bulk_ambiguous": "kilka produktów w katalogu Allegro — otwórz szkic i wybierz",
  "offer_drafts.bulk_blocked": "blokada",
  "offer_drafts.bulk_checking": "sprawdzam…",
  "offer_drafts.bulk_clear": "Odznacz",
  "offer_drafts.bulk_col_draft": "Szkic",
  "offer_drafts.bulk_confirm": "{n} ofert na wybranych kontach — każda to prawdziwa publikacja na Allegro.",
  "offer_drafts.bulk_confirm_draft_t": "Wysłać szkice na Allegro?",
  "offer_drafts.bulk_confirm_t": "Wystawić oferty na Allegro?",
  "offer_drafts.bulk_done": "Wystawiono {ok} z {n}",
  "offer_drafts.bulk_failed": "nie udało się",
  "offer_drafts.bulk_go": "Wystaw gotowe ({n})",
  "offer_drafts.bulk_go0": "Wystaw gotowe",
  "offer_drafts.bulk_go_draft": "Wyślij gotowe jako szkic ({n})",
  "offer_drafts.bulk_go_draft0": "Wyślij jako szkic",
  "offer_drafts.bulk_open": "otwórz szkic",
  "offer_drafts.bulk_publish": "Wystaw zaznaczone…",
  "offer_drafts.bulk_published": "wystawiona",
  "offer_drafts.bulk_ready": "gotowe",
  "offer_drafts.bulk_selected": "Zaznaczone: {n}",
  "offer_drafts.bulk_sent_draft": "szkic na Allegro",
  "offer_drafts.bulk_skip_active": "produkt ma tu aktywną ofertę",
  "offer_drafts.bulk_skip_pub": "już wystawiona z tego szkicu",
  "offer_drafts.bulk_title": "Wystaw seryjnie — {n} szkiców",
  "offer_drafts.bulk_unknown": "wynik nieustalony — otwórz szkic i rozstrzygnij",
  "offer_drafts.bulk_wait": "do sprawdzenia",
  "offer_drafts.on_accounts": "Allegro:",
  "offer_drafts.product_had_offer": "była oferta (zakończona)",
  "offer_drafts.product_has_offer": "produkt ma tu już aktywną ofertę",
  "offer_drafts.sel_disabled": "Najpierw powiąż produkt SellBase — dopiero wtedy szkic można wystawić seryjnie",
  "offer_drafts.sel_title": "Zaznacz do wystawienia seryjnego",
  "offer_drafts.hist_kind_z_produktu": "Szkic z karty produktu",
  "catalog.kind_product": "Produkt SellBase",
  "catalog.kind_component": "Komponent SellBase",
  "catalog.kind_component_hint": "Komponent: dokładany do paczki z innym produktem. Nie ma EAN ani ofert; koszt i stan liczy panel p4u po SKU.",
  "catalog.kind_multipack": "Wielopak SellBase",
  "catalog.kind_multipack_hint": "Wielopak SellBase: kilka sztuk jednego produktu SellBase (np. 6 × ten sam produkt).",
  "catalog.kind_multipack_option": "Jeden produkt SellBase × N sztuk (co najmniej 2), np. 6 × ten sam produkt. Nie mylić z „Wielopak Allegro” przy ofercie.",
  "catalog.kind_set": "Zestaw SellBase",
  "catalog.kind_set_hint": "Zestaw SellBase: różne produkty SellBase, każdy w dowolnej ilości.",
  "catalog.kind_set_option": "Różne produkty SellBase, każdy w dowolnej ilości",
  "catalog.kind_pending": "Zestaw (do złożenia)",
  "catalog.kind_pending_hint": "Rozpoznany jako zestaw — skład do uzupełnienia",
  "catalog.kind_pending_empty_hint": "Zestaw bez zapisanego składu — ustaw składniki przyciskiem „Zmień skład”.",
  "catalog.kind_1x1_hint": "Skład 1 × 1 szt. — sprawdź: wielopak to co najmniej 2 sztuki jednego produktu.",
  "catalog.kind_allegro_note": "To rodzaj karty SellBase. „Wielopak Allegro” to co innego — cecha oferty na Allegro (productSet), widoczna przy ofercie.",
  "catalog.kind_filter_bundle": "Wszystkie zestawy",
  "catalog.kind_filter_bundle_hint": "Wszystkie zestawy: wielopaki, zestawy SellBase i zestawy do złożenia",
  "catalog.kind_filter_multipack": "Wielopaki",
  "catalog.kind_filter_set": "Zestawy SellBase",
  "catalog.multipack_rule": "Wielopak SellBase to jeden produkt SellBase w ilości co najmniej 2 szt. Dla kilku różnych produktów wybierz „Zestaw SellBase”.",
  "catalog.multipack_editor_title": "Ustaw wielopak SellBase",
  "catalog.multipack_editor_intro": "Wybierz JEDEN produkt SellBase i liczbę sztuk (co najmniej 2), np. 6 × ten sam produkt. Różne produkty to „Zestaw SellBase”. „Wielopak Allegro” przy ofercie to osobna cecha oferty — tu ustawiasz rodzaj karty. Karta zachowa SKU, zdjęcia i historię.",
  "catalog.multipack_editor_parts": "Produkt w wielopaku",
  "catalog.multipack_dialog_new": "Zamień w wielopak SellBase",
  "catalog.multipack_dialog_change": "Ustaw jako wielopak SellBase",
  "catalog.multipack_saved": "Karta jest teraz wielopakiem SellBase.",
  "offer_drafts.s226_rodzaj": "Rodzaj karty",
  "offer_drafts.s226_sklad_laduje": "Szukam produktów z paczki w SellBase…",
  "offer_drafts.filter_done": "Zakończone",
  "offer_drafts.section_done": "Zakończone — obsługa w karcie produktu",
  "offer_drafts.cta_add_card": "Dodaj kartę SellBase",
  "offer_drafts.cap_add_card": "treść z paczki stanie się szablonem karty",
  "offer_drafts.cta_open_product": "Otwórz produkt",
  "offer_drafts.cap_done": "wystawianie i treść w karcie",
  "offer_drafts.cap_published_no_card": "oferta już na Allegro — brakuje karty",
  "offer_drafts.step2_done": "Wystawianie z karty produktu",
  "offer_drafts.step2_done_cov": "Allegro: na {a} z {n} kont",
  "offer_drafts.pick_karta": "Wystaw: {name}",
  "offer_drafts.pick_karta_draft": "Wyślij jako szkic: {name}",
  "offer_drafts.other_channels": "Inne marketplace’y",
  "offer_drafts.other_no_path": "wystawianie z karty niedostępne",
  "offer_drafts.activate_existing": "Aktywuj istniejącą",
  "offer_drafts.publish_new_anyway": "Wystaw nową",
  "offer_drafts.publish_second_anyway": "Wystaw drugą mimo to",
  "offer_drafts.activating": "Aktywuję ofertę…",
  "offer_drafts.activated": "Aktywowano istniejącą ofertę",
  "offer_drafts.card_ready_title": "Karta gotowa",
  "offer_drafts.card_ready_q": "Karta „{name}” jest w SellBase. Przejść do niej i wystawić ofertę na wybrane konta i marketplace’y?",
  "offer_drafts.card_ready_go": "Przejdź i wystaw",
  "offer_drafts.card_ready_later": "Później",
  "offer_drafts.pub_done_toast": "Wystawiono na {n} kont",
  "offer_drafts.change_in_card": "Powiązanie zmienisz w karcie produktu (Zarządzaj powiązaniami) — potem „Wystaw…” ponownie.",
  "offer_drafts.step1_match": "Dopasowana karta: ",
  "offer_drafts.step1_match_title": "Dopasowana karta SellBase — kliknij, aby ją otworzyć; „Wybierz produkt” ją powiąże",
  "offer_drafts.cap_match": "dopasowana karta — powiąż, treść pójdzie do szablonu",
  "offer_drafts.cap_match_published": "karta już jest — powiąż ją z wystawioną ofertą"
}
